import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl, IconButton
} from "@mui/material";
import moment from "moment";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import { FormControl } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
// import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import {
//   MuiPickersUtilsProvider,
//   DatePicker,
// } from "@mui/material/pickers";
import { Tooltip } from "antd";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { getCodes } from "../../utils/countriesDropdown";
import Layout from "../../components/Wrappers/Layout";
import { Alert, Row, Col, Card } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import { getWalletTransactionList } from "../../redux/actions/getWalletTransactionListAction";
import { generateWalletTransactionReportFileReq } from "../../redux/actions/generateWalletTransactionReportFileAction";
import { getUsernameContactsSuggestionForAdminList } from "../../redux/actions/adminGetUsernameContactSuggestionAction";
import Excel from "../../assets/img/excel.png";
import PDF from "../../assets/img/pdf1.png";
import getSymbolFromCurrency from "currency-symbol-map";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { adminCurrencyCode } from "../../redux/actions/adminCurrencyCodeAction";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { adminGetTransactionSubType } from "../../redux/actions/adminGetTransactionSubTypeAction";
import { AdmingetCustomerIDNAMELists } from "../../redux/actions/adminGetCustomerIdAndNameListAction";
import { getCode } from "../../utils/countries";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { sha256 } from "js-sha256";
import SearchIcon from "@mui/icons-material/Search";
import { getUpdateWalletTransactionStatusAdminLists, resetUpdateWalletTransactionStatusAdmin } from "../../redux/actions/updateWalletTransactionStatusAdminAction";
import { resetAdminGetRefundDetails, adminGetRefundDetails } from "../../redux/actions/adminGetRefundDetailsAdminAction";
import { getWalletTransactionListOnParent, resetGetWalletTransactionListOnParent } from "../../redux/actions/getWalletTransactionListOnParentAction";
import { getWalletTransactionListByIdAdmin, resetGetWalletTransByIdAdmin } from "../../redux/actions/getWalletTransactionListByIdAdminAction";
import { getFeeDetailsByIds } from "../../redux/actions/getFeeDetailsByIdPartnerAction";
import { FaCheckCircle } from "react-icons/fa"; // For success
import { MdCancel } from "react-icons/md";      // For failed
import { FaClock } from "react-icons/fa6"; // For pending
import { ImSpinner11 } from "react-icons/im"; //for proccessing
import { TiCancel } from "react-icons/ti"; //for cancelled
import { MdOutlineCancelPresentation } from "react-icons/md"; //for declined
import val from "../../getThemeDetails"
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function AdminWalletTransaction() {
  var date = new Date();
  const [selectedDate, setSelectedDate] = useState(
    new Date(date.getFullYear(), date.getMonth(), 1)
  );

  const [selectedToDate, setSelectedToDate] = useState(new Date());

  const [downloadBtn, setDownloadBtn] = useState(true);

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pageNo, setPageNo] = useState(0)
  const [isLoading, setIsLoading] = useState(false);

  const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
    useState([]);

  const [getWalletTransactionListArray, setGetWalletTransactionListArray] =
    useState([]);

  const [getWalletTransactionListStatus, setGetWalletTransactionListStatus] =
    useState(false);

  const [getTransactionReportFileResStatus, setGetTransactionReportFileRes] =
    useState(false);

  const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
  const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);
  const [boolSet, setboolSet] = useState(false);
  const [boolSetName, setboolSetName] = useState(false);
  const [invoiceid, setInvoiceid] = useState("")

  const [boolCustIDSet, setboolCustIDSet] = useState(false);

  const [autocompleteData, setautocompleteData] = useState("");
  const [autocompleteDataName, setautocompleteDataName] = useState("");

  const [autocompleteCustomerIDData, setautocompleteCustomerIDData] =
    useState("");
  const [viewUpdateResArray, setViewUpdateResArray] = useState([]);
  const [notificationRefundOpen, setNotificationRefundOpen] =
    React.useState(false);
  const [notificationUpdateStatusOpen, setNotificationUpdateStatusOpen] =
    React.useState(false);
  const Theme = useSelector((state) => state.theme.theme);


  const regenerateTokenRes = useSelector(
    ({ regenerateToken }) => regenerateToken
  );
  const partnerGetFeeDetailsByIDRes = useSelector(
    ({ partnerGetFeeDetailsById }) => partnerGetFeeDetailsById
  )
  var authToken = regenerateTokenRes.data.AuthToken;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [viewOpen, setViewOpen] = useState(false);

  const [toCustContact, setToCustContact] = useState("");
  const [toBalance, setToBalance] = useState("");
  const [TransactionStatus, setTransactionStatus] = useState("");
  const [ipAdd, setIpAdd] = useState("");
  const [Credit, setCredit] = useState("");
  const [Debit, setDebit] = useState("");
  const [remark, setRemark] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [fromCustID, setFromCustID] = useState("");
  const [fromDATE, setFromDATE] = useState("");
  const [IsFee, setIsFee] = useState("");
  const [toCustomerName, setToCustomerName] = useState("");
  const [TransactionAmt, setTransactionAmt] = useState("");
  const [fromCustName, setFromCustName] = useState("");
  const [isMasked, setIsMasked] = useState(true);
  const [isMaskedToContact, setIsMaskedToContact] = useState(true);
  const [transStatus, setTransStatus] = useState("");
  const [transactionSubTypeBool, settransactionSubTypeBool] = useState(false);
  const [toCustName, setToCustName] = useState("");
  const [custContact, setCustContact] = useState("");
  const [customerOrMobName, setCustomerOrMobName] = useState("");
  const [customerIDNameList, setcustomerIDNameList] = useState("");

  const [transactionSubTypeList, settransactionSubTypeList] = useState([]);

  const [updateStatus, setUpdateStatus] = useState("");
  const [parentDetails, setParentDetails] = useState(false);
  const [parentDetailsArr, setParentDetailsArr] = useState([])
  const [parentIdModal, setparentIdModal] = useState(false)
  const [open, setOpen] = useState(null);
  const [refundFlag, setRefundFlag] = useState(false)
  const [getFeeDetailsOpenModal, setGetFeeDetailsOpenModal] = useState(false);
  const [feeDetailsModal, setFeeDetailsModal] = useState(false)
  const [feeDetailsArr, setFeeDetailsArr] = useState([])
  const [getFeeDetailsListStatus, setGetFeeDetailsListStatus] =
    useState(false);

  const onButtonClick = (FromCustID) => {
    if (open == FromCustID) {
      setOpen(null);
    } else {
      setOpen(FromCustID);
    }
  };
  const [density, setdensity] = useState("");
  const [device, setdevice] = useState("");
  const [deviceMemory, setdeviceMemory] = useState("");
  const [deviceUUID, setdeviceUUID] = useState("");
  const [os, setos] = useState("");
  const [osVersion, setosVersion] = useState("");
  const [getRefundOpenModal, setGetRefundOpenModal] = useState(false);

  const [getWalletTransList, setGetWalletTransList] = useState([])


  // getWalletTransactionListById click on expand arrow then call API 
  const adminGetWalletTransactionListById = useSelector(
    ({ adminGetWalletTransactionByIdLists }) => adminGetWalletTransactionByIdLists
  )
  console.log("adminGetWalletTransactionListById", adminGetWalletTransactionListById)

  const getWalletTransactionListByIdReq = (walletOwnerId, transactionId, currency) => {
    const req = {
      walletTransactionMasterDetailsRequestVO: {
        walletOwnerId: walletOwnerId,
        currency: currency,
        transactionId: transactionId,
      }
    }
    dispatch(getWalletTransactionListByIdAdmin(req, authToken));
  }

  const viewTransactionDetailsResFunc = () => {
    if (adminGetWalletTransactionListById.data.status === "success") {
      setGetWalletTransList(
        adminGetWalletTransactionListById.data.transactionMasterDetailsResponseVO
      );
    }
    if (adminGetWalletTransactionListById.data.status == "Failed") {
      setGetWalletTransList(adminGetWalletTransactionListById.data);
      if (
        adminGetWalletTransactionListById.data.description == "session out"
      ) {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        adminGetWalletTransactionListById.data.description == "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
    }
  };

  useEffect(() => {
    viewTransactionDetailsResFunc()
  }, [adminGetWalletTransactionListById])


  function countryFlag(cNames) {

    let country = require("../../assets/img/CountryFlags/" + getCode(cNames).toLowerCase() + ".png")


    return country;
  }

  function countryFlagS(cName) {
    cName = cName.replace(/\w+/g,
      function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });

    let countryS = require("../../assets/img/CountryFlags/" + getCodes(cName).toLowerCase() + ".png")
    return countryS;
  }

  const handleChange = ({ target: { name, value } }) => {

    if (name === "toCustContact") {
      setToCustContact(value);
    }
    if (name === "toBalance") {
      setToBalance(value);
    }
    if (name === "TransactionStatus") {
      setTransactionStatus(value);
    }
    if (name === "transStatus") {
      setTransStatus(value);
    }
    if (name === "custContact") {
      setCustContact(value);
    }
    if (name === "toCustName") {
      Util.verifyAlphabet(value)
        ? setToCustName(value)
        : setToCustName(toCustName);
    }
    if (name === "customerOrMobName") {
      setCustomerOrMobName(value);
    }
    if (name === "customerIDNameList") {
      setcustomerIDNameList(value);
    }
    if (name === "ipAdd") {
      setIpAdd(value);
    }
    if (name === "Credit") {
      setCredit(value);
    }
    if (name === "Debit") {
      setDebit(value);
    }
    if (name === "remark") {
      setRemark(value);
    }
    if (name === "Currency") {
      setToCurrency(value);
    }
    if (name === "FromCustomerId") {
      setFromCustID(value);
    }
    if (name === "density") {
      setdensity(value);
    }
    if (name === "device") {
      setdevice(value);
    }
    if (name === "deviceMemory") {
      setdeviceMemory(value);
    }
    if (name === "deviceUUID") {
      setdeviceUUID(value);
    }
    if (name === "os") {
      setos(value);
    }
    if (name === "osVersion") {
      setosVersion(value);
    }

    if (name === "orgnDesc") {
      console.log("VALUESSSS", value);
      setorgnDesc(value);
    }
    if (name === "updateStatus") {
      setUpdateStatus(value);
      // setIsFee(value == "All" ? "" : value);
      console.log("chaaan", updateStatus, getRemark);

    }
    if (name === "getRemark") {

      setGetRemark(value);
      console.log("chaaan", updateStatus, getRemark);
    }
    if (name === "invoiceid") {
      setInvoiceid(value)
    }
  };

  const closeEditModal = () => {
    setViewOpen(false);
    setParentDetails(false);
  };

  const handleParentOpen = (parentid) => {
    // console.log("TRANSIIDDDD", transactionId)
    // setParentDetails(true)
    // getParentDetailsReq(OnClick, currency)
    // setTransactionId(transactionId)
    // getWalletTransactionListReq()
    getWalletTransactionListOnParentReq(parentid);
    // setTransactionId('')
    //     let filteredParent= [].concat(getWalletTransactionListArray).filter((el)=>el.transactionId==parentid)[0]
    // setParentDetailsArr({...filteredParent})
    // setparentIdModal(true)
  };
  const handleFeeDetailsOpen = (transID, walletOID) => {
    setGetFeeDetailsOpenModal(true)
    getFeeDetailsListReq(transID, walletOID)

  }
  const getFeeDetailsListReq = (transID, walletOID) => {
    setGetFeeDetailsListStatus(true)
    const req = {
      actionCustomerMasterRequestVO: {
        walletOwnerId: transID,
        transactionId: walletOID
      }
    }
    // console.log("REQQQ",req)
    return dispatch(
      getFeeDetailsByIds(req, authToken)
    );
  }

  useEffect(() => {
    partnerGetFeeDetailsListFunc();
  }, [partnerGetFeeDetailsByIDRes]);


  const partnerGetFeeDetailsListFunc = () => {
    if (partnerGetFeeDetailsByIDRes && partnerGetFeeDetailsByIDRes.data) {
      if (partnerGetFeeDetailsByIDRes.data.status === "success") {
        setFeeDetailsModal(true);
        setFeeDetailsArr([].concat(partnerGetFeeDetailsByIDRes.data.Response));
      } else if (
        partnerGetFeeDetailsByIDRes.data.status === "failed" ||
        partnerGetFeeDetailsByIDRes.data.status === "Failed"
      ) {
        setFeeDetailsModal(false);

        if (partnerGetFeeDetailsByIDRes.data.description === "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        } else if (
          partnerGetFeeDetailsByIDRes.data.description === "Authorization failed"
        ) {
          regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
        } else if (partnerGetFeeDetailsByIDRes.data.status === "Not found") {
          setCustomerOrMobName([]);
        }
      }
    } else {
      console.log('partnerGetFeeDetailsByIDRes is undefined or missing data');
    }
  };

  const [getParentIdOnClick, setGetParentIdOnClick] = useState("");
  const [getRemark, setGetRemark] = useState("");

  const [user, setUser] = useState({
    walletOwnerId: "",
    fromCustomerId: "",
    transactionId: "",
    transactionType: "",
    currency: "",
    isFee: "",
    transactionSubType: "",
    feeType: "",
  });

  const {
    walletOwnerId,
    fromCustomerId,
    transactionId,
    transactionType,
    currency,
    isFee,
    transactionSubType,
    feeType,
  } = user;

  const onInputChange = ({ target: { name, value } }, type) => {
    const obj = {
      ...user,
    };

    if (type == "number") {
      obj[name] = Util.verifyMobile(value) ? value : obj[name];
    } else if (type == "alphabet") {
      obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
    } else if (type == "both") {
      obj[name] = Util.alphaNumeric(value) ? value : obj[name];
    } else {
      obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
    }
    if (name === "walletOwnerId") {
      setautocompleteData("");
      setautocompleteDataName("");


      setautocompleteCustomerIDData("");
      obj["transactionType"] = "Select Transaction Type";
    }
    if (name === "transactionType") {
      const req = {
        actionCustomerMasterRequestVO: {
          walletOwnerId: walletOwnerId,
          transactionType: value === "Select Transaction Type" ? "" : value,
        },
      };
      dispatch(adminGetTransactionSubType(req, authToken));
      settransactionSubTypeBool(true);
    }
    setUser(obj);
  };

  const getRefundDetailsAdminReq = (walletOwnerId, transactionId) => {
    const req = {
      actionCustomerMasterRequestVO: {
        walletOwnerId: walletOwnerId,
        transactionId: transactionId,
      }
    };

    dispatch(adminGetRefundDetails(req, authToken))
  };








  useEffect(() => {
    console.log(user, "//////////////////////////user");
  }, [user]);

  useEffect(() => {
    const adminCurrReq = {
      loginDetails: {
        adminId: regenerateTokenRes.data.partnerId,
      },
    };
    dispatch(adminCurrencyCode(adminCurrReq, authToken));
  }, [authToken]);

  const adminCurrencyCodes = useSelector(
    ({ adminCurrencyCode }) => adminCurrencyCode
  );
  const AdminGetUsernameContactSuggestionRes = useSelector(
    ({ adminGetUserNameContactSuggestionsLists }) =>
      adminGetUserNameContactSuggestionsLists
  );
  const AdminGetUsernameSuggestionRes = useSelector(
    ({ adminGetUserNameContactSuggestionsLists }) =>
      adminGetUserNameContactSuggestionsLists
  );
  const adminGetTransactionSubTyeRes = useSelector(
    ({ adminGetTransactionSubTye }) => adminGetTransactionSubTye
  );

  const admingetCustomerIDandNameListRes = useSelector(
    ({ adminGetCustomerIDAndNamesLists }) => adminGetCustomerIDAndNamesLists
  );

  const adminUpdateWalletTransactionStatusRes = useSelector(
    ({ adminUpdateWalletTransactionStatusList }) =>
      adminUpdateWalletTransactionStatusList
  );
  const adminGetRefundDetailsRes = useSelector(
    ({ adminGetRefundDetailsList }) => adminGetRefundDetailsList
  );


  const [dataAutocomplete, setdataAutocomplete] = useState([]);
  const [dataAutocompleteName, setdataAutocompleteName] = useState([]);

  const [dataAutocompleteCustID, setdataAutocompleteCustID] = useState([]);

  const [orgnDesc, setorgnDesc] = useState("");
  const [openUpdateModal, setOpenUpdateModal] = React.useState(false);

  const setDataAutocompleteFunc = () => {
    if (boolSet) {
      if (AdminGetUsernameContactSuggestionRes.data.status === "Success") {
        setdataAutocomplete(AdminGetUsernameContactSuggestionRes.data.list);
      }
      if (AdminGetUsernameContactSuggestionRes.data.status === "Failed") {
        if (
          AdminGetUsernameContactSuggestionRes.data.description == "session out"
        ) {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          AdminGetUsernameContactSuggestionRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
      if (AdminGetUsernameContactSuggestionRes.data.status === "Not found") {
        setdataAutocomplete([]);
      }
    }
  };
  //Name autocomplete
  const setDataAutocompleteNameFunc = () => {
    if (boolSetName) {
      if (AdminGetUsernameSuggestionRes.data.status === "Success") {
        setdataAutocompleteName(AdminGetUsernameSuggestionRes.data.list);
      }
      if (AdminGetUsernameSuggestionRes.data.status === "Failed") {
        if (
          AdminGetUsernameSuggestionRes.data.description == "session out"
        ) {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          AdminGetUsernameSuggestionRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
      if (AdminGetUsernameSuggestionRes.data.status === "Not found") {
        setdataAutocompleteName([]);
      }
    }
  };

  const handleClose = () => {
    setOpenUpdateModal(false);
    setGetFeeDetailsOpenModal(false)
    setGetRefundOpenModal(false)
    setUpdateStatus("")
    setRemark("")
  };
  const handleNoticationClose = () => {
    setNotificationRefundOpen(false);
    handleClose()
    setNotificationUpdateStatusOpen(false)
  };

  useEffect(() => {
    setDataAutocompleteFunc();
  }, [AdminGetUsernameContactSuggestionRes.data.status]);

  useEffect(() => {
    setDataAutocompleteNameFunc();
  }, [AdminGetUsernameSuggestionRes.data.status]);

  const setDataAutocompleteCustIdFuncs = () => {
    if (boolCustIDSet) {
      if (admingetCustomerIDandNameListRes.data.status === "Success") {
        setdataAutocompleteCustID(
          admingetCustomerIDandNameListRes.data.customerList
        );
      }
      if (admingetCustomerIDandNameListRes.data.status === "Failed") {
        if (
          admingetCustomerIDandNameListRes.data.description == "session out"
        ) {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          admingetCustomerIDandNameListRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
      if (admingetCustomerIDandNameListRes.data.status === "Not found") {
        setdataAutocompleteCustID([]);
      }
    }
  };

  useEffect(() => {
    setDataAutocompleteCustIdFuncs();
  }, [admingetCustomerIDandNameListRes.data.status]);

  useEffect(() => {
    setGetRefundOpenModal(false);

    dispatch(resetAdminGetRefundDetails())
    return () => {
      setGetRefundOpenModal(false);

      dispatch(resetAdminGetRefundDetails())
    }
  }, [])



  useEffect(() => {
    console.log("adminGetRefundDetailsRestttt", adminGetRefundDetailsRes);

    if (adminGetRefundDetailsRes.data.status) {
      adminGetRefundDetailsFunc()
    }
    // return ()=>{
    // setGetRefundOpenModal(false);

    //   dispatch(resetAdminGetRefundDetails())
    // }
  }, [adminGetRefundDetailsRes])


  const adminGetRefundDetailsFunc = () => {
    if (adminGetRefundDetailsRes.data.status === "success") {
      setRefundFlag(true)
      // setGetRefundOpenModal(true);

    }
    if (adminGetRefundDetailsRes.data.status == "failed" || adminGetRefundDetailsRes.data.status == "Failed") {
      // setGetRefundOpenModal(true);
      setRefundFlag(false)

      if (
        adminGetRefundDetailsRes.data.description == "session out"
      ) {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        adminGetRefundDetailsRes.data.description ==
        "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (adminGetRefundDetailsRes.data.status === "Not found") {
        setCustomerOrMobName([]);
      }
    }
  };



  console.log(adminGetRefundDetailsRes, "adminGetRefundDetailsResss");

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleToDateChange = (date) => {
    setSelectedToDate(date);
  };

  const getTransactionTypeListRes = useSelector(
    ({ getTransactionTypeList }) => getTransactionTypeList
  );

  const getWalletTransactionListRes = useSelector(
    ({ getWalletTransactionList }) => getWalletTransactionList
  );
  const getWalletTransactionListOnParentRes = useSelector(
    ({ getWalletTransactionOnParentList }) => getWalletTransactionOnParentList
  );

  const generateWalletTransactionReportFileRes = useSelector(
    ({ generateWalletTransactionReportFile }) =>
      generateWalletTransactionReportFile
  );

  const getWalletOwnerIdRes = useSelector(
    ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
  );

  const getAutoCustNameFunc = () => {
    if (AdminGetUsernameContactSuggestionRes.data.status === "success") {
      setCustomerOrMobName(
        [].concat(AdminGetUsernameContactSuggestionRes.data.list)
      );
    }
    if (AdminGetUsernameContactSuggestionRes.data.status == "failed") {
      setCustomerOrMobName(AdminGetUsernameContactSuggestionRes.data);
      if (
        AdminGetUsernameContactSuggestionRes.data.description == "session out"
      ) {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        AdminGetUsernameContactSuggestionRes.data.description ==
        "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (AdminGetUsernameContactSuggestionRes.data.status === "Not found") {
        setCustomerOrMobName([]);
      }
    }
  };

  useEffect(() => {
    getAutoCustNameFunc();
  }, [AdminGetUsernameContactSuggestionRes.data.status]);

  //name autocomple req
  useEffect(() => {
    setautocompleteDataName("");
    if (walletOwnerId) {
      const getUserContactSuggestionReq = {
        actionCustomerMasterRequestVO: {
          customerMobileOrName: "",
          walletOwnerId: walletOwnerId,
        },
      };
      dispatch(
        getUsernameContactsSuggestionForAdminList(
          getUserContactSuggestionReq,
          authToken
        )
      );
      setboolSetName(true);
    }
  }, [walletOwnerId]);

  useEffect(() => {
    setautocompleteData("");
    if (walletOwnerId) {
      const getUserContactSuggestionReq = {
        actionCustomerMasterRequestVO: {
          customerMobileOrName: "",
          walletOwnerId: walletOwnerId,
        },
      };
      dispatch(
        getUsernameContactsSuggestionForAdminList(
          getUserContactSuggestionReq,
          authToken
        )
      );
      setboolSet(true);
    }
  }, [walletOwnerId]);

  const getAutoCustomerIDFunc = () => {
    if (admingetCustomerIDandNameListRes.data.status === "success") {
      setcustomerIDNameList(admingetCustomerIDandNameListRes.data.customerList);
    }
    if (admingetCustomerIDandNameListRes.data.status == "failed") {
      setcustomerIDNameList(admingetCustomerIDandNameListRes.data);
      if (admingetCustomerIDandNameListRes.data.description == "session out") {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        admingetCustomerIDandNameListRes.data.description ==
        "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (admingetCustomerIDandNameListRes.data.status === "Not found") {
        setcustomerIDNameList([]);
      }
    }
  };
  useEffect(() => {
    getAutoCustomerIDFunc();
  }, [admingetCustomerIDandNameListRes.data.status]);

  useEffect(() => {
    setautocompleteCustomerIDData("");
    if (walletOwnerId) {
      const getCustomerIdAndNameReq = {
        actionCustomerMasterRequestVO: {
          customerNameOrId: "",
          walletOwnerId: walletOwnerId,
        },
      };
      dispatch(AdmingetCustomerIDNAMELists(getCustomerIdAndNameReq, authToken));
      setboolCustIDSet(true);
    }
  }, [walletOwnerId]);

  const getTransactionTypeListFunc = () => {
    if (getTransactionTypeListRes.data.status == "success") {
      setGetTransactionTypeListResArray(
        getTransactionTypeListRes.data.transactionType
      );
    }
  };

  useEffect(() => {
    getTransactionTypeListFunc();
  }, [getTransactionTypeListRes.data.status]);

  useEffect(() => {
    if (regenerateTokenRes.data.status == "success") {
      getTransactionTypeListReqApi();
      getWalletOwnerIdAndNameListReq();
    }
  }, [regenerateTokenRes.data.AuthToken]);

  const getTransactionTypeListReqApi = () => {
    const getTransactionTypeListReq = {
      loginDetails: {
        walletOwnerId: "1",
      },
    };

    return dispatch(
      getTransactionTypeListDetails(getTransactionTypeListReq, authToken)
    );
  };

  const getWalletOwnerIdStatusFunc = () => {
    if (getWalletOwnerIdStatus) {
      if (getWalletOwnerIdRes.data.status == "success") {
        setGetWalletOwnerIdResArray(
          [].concat(getWalletOwnerIdRes.data.ownerList)
        );
      }
      if (getWalletOwnerIdRes.data.status == "failed") {
        setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
        if (getWalletOwnerIdRes.data.description == "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (getWalletOwnerIdRes.data.description == "Authorization failed") {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
    }
  };

  const getWalletOwnerIdAndNameListReq = () => {
    setGetWalletOwnerIdStatus(true);
    dispatch(
      getWalletOwnerIdAndNameList(
        {
          loginDetails: {
            // adminId: "2",
            adminId: val.adminIDS

          },
        },
        authToken
      )
    );
  };

  useEffect(() => {
    getWalletOwnerIdStatusFunc();
  }, [getWalletOwnerIdRes.data.status]);

  const getWalletTransactionListOnParentReq = (parentId) => {
    setIsLoading(true);
    setDownloadBtn(true);
    setGetWalletTransactionListStatus(true);
    const getTransactionTypeListReqIs = {
      walletTransactionMasterDetailsRequestVO: {
        walletOwnerId:
          walletOwnerId == "Select Owner Id" ? "" : walletOwnerId.split("-")[0],
        currency: currency,
        fromDate: moment(selectedDate).format("DD/MM/YYYY"),
        toDate: moment(selectedToDate).format("DD/MM/YYYY"),
        transactionId: parentId,
        isFee: "",
        transactionType:
          "",
        // walletCustomerId: fromCustomerId,
        walletCustomerId: "",
        toCustomerName: "",
        toCustomerContact: "",
        status: "",
        transactionSubType:
          ""
        ,
        feeType: ""
      },
    };
    return dispatch(
      getWalletTransactionListOnParent(getTransactionTypeListReqIs, authToken)
    );
  };

  const getWalletTransactionListReq = () => {
    setIsLoading(true);
    setDownloadBtn(true);
    setGetWalletTransactionListStatus(true);
    const getTransactionTypeListReqIs = {
      walletTransactionMasterDetailsRequestVO: {
        walletOwnerId:
          walletOwnerId == "Select Owner Id" ? "" : walletOwnerId.split("-")[0],
        currency: currency,
        fromDate: moment(selectedDate).format("DD/MM/YYYY"),
        toDate: moment(selectedToDate).format("DD/MM/YYYY"),
        transactionId: transactionId,
        isFee: isFee,
        transactionType:
          transactionType == "Select Transaction Type" ? "" : transactionType,
        // walletCustomerId: fromCustomerId,
        walletCustomerId: autocompleteCustomerIDData.split("-")[0],
        toCustomerName: autocompleteDataName
          ? autocompleteDataName.customerMobileOrName
          : "",
        toCustomerContact: autocompleteData
          ? autocompleteData.countryCode + " " + autocompleteData.mobile
          : "",
        status: transStatus === "All" ? "" : transStatus,
        transactionSubType:
          transactionSubType === "Select Transaction Sub Type"
            ? ""
            : transactionSubType,
        feeType: feeType === "Select Fee Type" ? "" : feeType,
        // pageNo: transactionId ? 1 : pageNo + 1,
        pageNo: pageNumberOne() ? 1 : pageNo + 1,
        records: rowsPerPage,
        orderDescription: invoiceid,
      },
    };
    return dispatch(
      getWalletTransactionList(getTransactionTypeListReqIs, authToken)
    );
  };
  useEffect(() => {
    if (currency) {
      getWalletTransactionListReq();
    }

  }, [pageNo, rowsPerPage])
  useEffect(() => {
    console.log("getWalletTransactionListRes", getWalletTransactionListRes);
    if (getWalletTransactionListRes.data.status) { getWalletTransactionListFun(); }
  }, [getWalletTransactionListRes]);

  // IF ANY ONE ENTITY FOUND THEN PAGE NUMBER 1 GOING TO getWalletTransactionListReq THIS REQUEST  
  // function pageNumberOne() {
  //   if (transactionId || transStatus || feeType || autocompleteDataName || autocompleteData || transactionType || isFee) {
  //     return 1
  //   } else {
  //     return 0
  //   }
  // }

  function pageNumberOne() {
  return (
    // Transaction ID
    (transactionId && transactionId.trim() !== "") ||

    // Invoice ID filter (NEW)
    (invoiceid && invoiceid.trim() !== "") ||

    // Status
    (transStatus && transStatus !== "" && transStatus !== "All") ||

    // Transaction Type
    (transactionType && transactionType !== "" && transactionType !== "Select Transaction Type") ||

    // Fee Type
    (feeType && feeType !== "" && feeType !== "Select Fee Type") ||

    // IsFee
    (isFee && isFee !== "" && isFee !== "Select Fee") ||

    // Autocomplete Contact
    (autocompleteData && autocompleteData.mobile) ||

    // Autocomplete Name
    (autocompleteDataName && autocompleteDataName.customerMobileOrName)
  );
}

  useEffect(() => {
    console.log("getWalletTransactionListOnParentRes", getWalletTransactionListOnParentRes);
    if (getWalletTransactionListOnParentRes.data.status) {
      getWalletTransactionListOnParentFun()
      getWalletTransactionListFun()
    }

  }, [getWalletTransactionListOnParentRes]);






  useEffect(() => {

    return () => {
      dispatch(resetGetWalletTransactionListOnParent())
      setparentIdModal(false)

    }
  }, []);



  const getWalletTransactionListOnParentFun = () => {

    if (getWalletTransactionListOnParentRes.data.status == "success") {
      // setGetWalletTransactionListArray(
      //   [].concat(getWalletTransactionListRes.data.transactionList)
      // );
      setparentIdModal(true)
      setParentDetailsArr([].concat(getWalletTransactionListOnParentRes.data.transactionList)[0])
      // setIsLoading(false);
      // setDownloadBtn(false);
    }
    if (getWalletTransactionListOnParentRes.data.status == "failed") {
      // setGetWalletTransactionListArray(getWalletTransactionListOnParentRes.data);
      // setIsLoading(false);
      // setDownloadBtn(true);
      NotificationPopups(
        "error",
        "Failed",
        getWalletTransactionListOnParentRes.data.description ||
        getWalletTransactionListOnParentRes.description
      );
      if (getWalletTransactionListOnParentRes.data.description == "session out") {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        getWalletTransactionListOnParentRes.data.description == "Authorization failed"
      ) {
        regenerateToken(
          dispatch,
          authToken,
          regenerateTokenRes.data.partnerId
        );
      }
    }

    if (getWalletTransactionListOnParentRes.data.status == "Failed") {
      // setGetWalletTransactionListArray(getWalletTransactionListOnParentRes.data);
      setIsLoading(false);
      setDownloadBtn(true);
      NotificationPopups(
        "error",
        "Failed",
        getWalletTransactionListOnParentRes.data.description ||
        getWalletTransactionListOnParentRes.description
      );
      if (getWalletTransactionListOnParentRes.data.description == "session out") {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        getWalletTransactionListOnParentRes.data.description == "Authorization failed"
      ) {
        regenerateToken(
          dispatch,
          authToken,
          regenerateTokenRes.data.partnerId
        );
      }
    }

    if (getWalletTransactionListOnParentRes.data.status == "NOT FOUND") {
      // setGetWalletTransactionListArray(getWalletTransactionListOnParentRes.data);
      setIsLoading(false);
      setDownloadBtn(true);
      NotificationPopups(
        "error",
        "NOT FOUND",
        getWalletTransactionListOnParentRes.data.status
      );
    }

  };



  const getWalletTransactionListFun = () => {
    if (getWalletTransactionListStatus) {
      if (getWalletTransactionListRes.data.status == "success") {
        setGetWalletTransactionListArray(
          [].concat(getWalletTransactionListRes.data.transactionList)
        );
        setIsLoading(false);
        setDownloadBtn(false);
      }
      if (getWalletTransactionListRes.data.status == "failed") {
        setGetWalletTransactionListArray(getWalletTransactionListRes.data);
        setIsLoading(false);
        setDownloadBtn(true);
        NotificationPopups(
          "error",
          "Failed",
          getWalletTransactionListRes.data.description ||
          getWalletTransactionListRes.description
        );
        if (getWalletTransactionListRes.data.description == "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          getWalletTransactionListRes.data.description == "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }

      if (getWalletTransactionListRes.data.status == "Failed") {
        setGetWalletTransactionListArray(getWalletTransactionListRes.data);
        setIsLoading(false);
        setDownloadBtn(true);
        NotificationPopups(
          "error",
          "Failed",
          getWalletTransactionListRes.data.description ||
          getWalletTransactionListRes.description
        );
        if (getWalletTransactionListRes.data.description == "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          getWalletTransactionListRes.data.description == "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }

      if (getWalletTransactionListRes.data.status == "NOT FOUND") {
        setGetWalletTransactionListArray(getWalletTransactionListRes.data);
        setIsLoading(false);
        setDownloadBtn(true);
        NotificationPopups(
          "error",
          "NOT FOUND",
          getWalletTransactionListRes.data.status
        );
      }
    }
  };

  useEffect(() => {
    if (getWalletTransactionListRes.data.status == "success") {
      // setPage(0);
    }
  }, [getWalletTransactionListRes.data.status]);
  const handleChangePageForward = (pageaa, newPage) => {
    setPageNo(newPage);

    // getWalletTransactionListReq()
    console.log("Arrow", newPage)
  };

  const handleChangeRowsPerPage = (event) => {

    setRowsPerPage(parseInt(event.target.value));
    setPageNo(0);

  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  const exportToExcel = () => {
    if (getWalletTransactionListArray.length !== undefined) {
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(getWalletTransactionListArray);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
      XLSX.writeFile(wb, "WalletTransaction.xlsx");
    }
  };

  const exportToPdf = () => {
    const doc = new jsPDF();
    doc.autoTable({
      html: "#walletTransation",
      styles: {
        halign: "center",
        valign: "middle",
        cellWidth: "auto",
        fontSize: 7,
      },
    });
    doc.save("WalletTransaction.pdf");
  };

  const csv = "1";
  const pdf = "0";

  const getTransactionReportFileExcelOrPdf = (csvOrPdf) => {
    setGetTransactionReportFileRes(true);
    const getTransactionReportListObj = {
      loginDetails: {
        walletOwnerId:
          walletOwnerId == "Select Owner Id" ? "" : walletOwnerId.split("-")[0],
      },
      walletTransactionMasterDetailsRequestVO: {
        currency: currency,
        fromDate: moment(selectedDate).format("DD/MM/YYYY"),
        toDate: moment(selectedToDate).format("DD/MM/YYYY"),
        transactionId: transactionId,
        isFee: isFee,
        walletCustomerId: fromCustomerId,
        reportFileType: csvOrPdf == "1" ? "csv" : "pdf",
      },
    };

    return dispatch(
      generateWalletTransactionReportFileReq(
        getTransactionReportListObj,
        authToken
      )
    );
  };

  const updateHandleClick = (TranID) => {
    setorgnDesc(TranID);
    setOpenUpdateModal(true);
  };

  const getUpdateGateWayReq = () => {
    const request = {
      actionCustomerMasterRequestVO: {
        status: updateStatus,
        id: orgnDesc,
        remark: getRemark,
        initiatedBy: "admin",
        walletOwnerId: walletOwnerId
      },
    };
    // console.log("REQUESTTTTTT", request)
    dispatch(getUpdateWalletTransactionStatusAdminLists(request, authToken));
  };

  useEffect(() => {
    console.log("UPDATEGATEWAYssssrr", adminUpdateWalletTransactionStatusRes);
    // console.log("");
    if (adminUpdateWalletTransactionStatusRes.data.status) {
      getUpdateGateWayFunc();
    }


  }, [adminUpdateWalletTransactionStatusRes]);

  useEffect(() => {
    return () => {
      dispatch(resetUpdateWalletTransactionStatusAdmin())
    }
  }, [])

  const getUpdateGateWayFunc = () => {
    console.log("UPDATEGATEWAYssss", adminUpdateWalletTransactionStatusRes);
    if (adminUpdateWalletTransactionStatusRes.data.status === "success") {
      console.log("INSIDE CONSOLE SUCCESS");
      setViewUpdateResArray(adminUpdateWalletTransactionStatusRes.data);
      setNotificationUpdateStatusOpen(true)
      // setNotificationRefundOpen(true);

      getWalletTransactionListReq();
      // setInquiryOpenModal(true)
    }
    if (adminUpdateWalletTransactionStatusRes.data.status == "Failed") {
      setViewUpdateResArray(adminUpdateWalletTransactionStatusRes.data);
      // setNotificationRefundOpen(true);
      notificationUpdateStatusOpen(true)
      if (
        adminUpdateWalletTransactionStatusRes.data.description == "session out"
      ) {
        SOLogout(
          dispatch,
          authToken,
          adminUpdateWalletTransactionStatusRes.data.partnerId
        );
      }
      if (
        adminUpdateWalletTransactionStatusRes.data.description ==
        "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
    }
    if (adminUpdateWalletTransactionStatusRes.data.status == "not found") {
      setViewUpdateResArray(adminUpdateWalletTransactionStatusRes.data);
      setNotificationRefundOpen(true);
      if (
        adminUpdateWalletTransactionStatusRes.data.description == "session out"
      ) {
        SOLogout(
          dispatch,
          authToken,
          adminUpdateWalletTransactionStatusRes.data.partnerId
        );
      }
      if (
        adminUpdateWalletTransactionStatusRes.data.description ==
        "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
    }
    if (adminUpdateWalletTransactionStatusRes.data.status == "failed") {
      setViewUpdateResArray(adminUpdateWalletTransactionStatusRes.data);
      setNotificationRefundOpen(true);
      if (
        adminUpdateWalletTransactionStatusRes.data.description == "session out"
      ) {
        SOLogout(
          dispatch,
          authToken,
          adminUpdateWalletTransactionStatusRes.data.partnerId
        );
      }
      if (
        adminUpdateWalletTransactionStatusRes.data.description ==
        "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
    }
  };

  useEffect(() => {
    if (getTransactionReportFileResStatus) {
      if (generateWalletTransactionReportFileRes.data.status == "success") {
        var link = document.createElement("a");
        link.download = generateWalletTransactionReportFileRes.data.fileName;
        link.href =
          "data:application/octet-stream;base64," +
          generateWalletTransactionReportFileRes.data.fileDate.split(`,`)[1];
        link.click();
      }
    }
  }, [generateWalletTransactionReportFileRes.data.status]);

  // useEffect(() => {
  // 	if (admingetCustomerIDandNameListRes.data.status === "success") {
  // 		console.log("lissttt", admingetCustomerIDandNameListRes.data.customerList)
  // 	}
  // }, [admingetCustomerIDandNameListRes.data.status])

  // useEffect(() => {
  // 	if (regenerateTokenRes.data.status === "success") {
  // 		const getCustomerIdAndNameReq = {

  // 			actionCustomerMasterRequestVO: {
  // 				walletOwnerId: walletOwnerId,
  // 				customerNameOrId: ""
  // 			}
  // 		};

  // 		dispatch(AdmingetCustomerIDNAMELists(getCustomerIdAndNameReq, authToken));
  // 	}
  // }, [regenerateTokenRes.data.status]);

  const filterOptionsL = (options, { inputValue }) => {
    if (inputValue.length < 3) {
      return [];
    }

    const filterOptionsList = options.filter(
      (option) => option.includes(inputValue) || ""
    );

    return filterOptionsList.slice(0, 20);
  };

  const filterOptions = (options, { inputValue }) => {
    if (inputValue.length < 3) {
      return [];
    }

    const filteredOptions = options.filter(
      (option) =>
        option.mobile.includes(inputValue) ||
        option.customerMobileOrName.includes(inputValue)
    );

    return filteredOptions.slice(0, 20);
  };

  const setTransactionSubType = () => {
    if (transactionSubTypeBool) {
      if (adminGetTransactionSubTyeRes.data.status === "Success") {
        settransactionSubTypeList(
          [].concat(adminGetTransactionSubTyeRes.data.transactionSubtype)
        );
      }
      if (adminGetTransactionSubTyeRes.data.status === "Fail") {
        NotificationPopups(
          "error",
          "Failed",
          adminGetTransactionSubTyeRes.data.description ||
          adminGetTransactionSubTyeRes.description
        );
        if (adminGetTransactionSubTyeRes.data.description == "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          adminGetTransactionSubTyeRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
      if (adminGetTransactionSubTyeRes.data.status === "failed") {
        NotificationPopups(
          "error",
          "Failed",
          adminGetTransactionSubTyeRes.data.description ||
          adminGetTransactionSubTyeRes.description
        );
        if (adminGetTransactionSubTyeRes.data.description == "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          adminGetTransactionSubTyeRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
      if (adminGetTransactionSubTyeRes.data.status === "NOT FOUND") {

        let transactionSubtype = [adminGetTransactionSubTyeRes.data.status]
        settransactionSubTypeList(transactionSubtype);

        // NotificationPopups(
        //   "error",
        //   "Failed",
        //   adminGetTransactionSubTyeRes.data.description ||
        //   adminGetTransactionSubTyeRes.description
        // );
        if (adminGetTransactionSubTyeRes.data.description == "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          adminGetTransactionSubTyeRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }

    }
  };

  useEffect(() => {
    setTransactionSubType();
  }, [adminGetTransactionSubTyeRes]);

  const countryFlags = (cname) => {
    let country = require("../../assets/img/CountryFlags/" +
      getCode(cname).toLowerCase() +
      ".png");
    return country;
  };
    const invoiceLabelS = (
    val.walletOwnerId === "199" ||
    val.walletOwnerId === "201" ||
    val.walletOwnerId === "200"
  ) ? "Invoice Id" : "Order Description";

  return (
    <>
      <Layout>
        <Card>
          <Grid
            container
            spacing={2}
            style={{ padding: "25px", marginTop: "2rem" }}
          >
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="From Date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    disableFuture={true}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="To Date"
                    format="MM/dd/yyyy"
                    value={selectedToDate}
                    onChange={handleToDateChange}
                    disableFuture={true}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                // margin="dense"
                required
                select
                size="small"
                color="primary"
                type="text"
                variant="standard"
                label="Owner ID"
                fullWidth={true}
                style={{ marginTop: "3px" }}
                name="walletOwnerId"
                // value={walletOwnerId}
                defaultValue={"Select Owner Id" || walletOwnerId}
                onChange={(e) => onInputChange(e)}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // White color for the underline before focus
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "gray", // White color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "gray", // White color after focus
                  },
                }}
              >
                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                  Select Owner Id
                </MenuItem>
                {getWalletOwnerIdRes.data.ownerList &&
                  getWalletOwnerIdResArray.map((x) => (
                    <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                  ))}
              </TextField>
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4} lg={3}> */}
            {/* <TextField
								size="small"
								color="primary"
								type="text"
								required
								label="From Customer ID"
								fullWidth={true}
								name="fromCustomerId"
								value={fromCustomerId}
								onChange={(e) => onInputChange(e, "number")}
							></TextField> */}
            {/* <Autocomplete
								id="combo-box-demo"
								options={[].concat(
									admingetCustomerIDandNameListRes.data.customerList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer ID"
										style={{ marginTop: "3px" }}
										required
										type="tel"
										fullWidth
										{...params}
										value={fromCustomerId}
										name="fromCustomerId"
										onBlur={handleChange}
									/>
								)}
							/> */}
            {/* </Grid> */}
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Autocomplete
                id="combo-box-demo"
                // options={dataAutocompleteCustID || []}
                options={[].concat(
                  admingetCustomerIDandNameListRes.data.customerList || [""]
                )}
                getOptionLabel={(option) => option}
                // getOptionLabel={(option) => option ? '+' + option.countryCode + ' ' + option.mobile + "-" + option.customerMobileOrName : ``}
                filterOptions={filterOptionsL}
                value={autocompleteCustomerIDData}
                onChange={(event, value) =>
                  setautocompleteCustomerIDData(value)
                }
                renderInput={(params) => (
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Customer ID"
                    variant="standard"

                    style={{ marginTop: "3px" }}
                    type="text"
                    fullWidth
                    {...params}
                    name="customerIDNameList"
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "gray", // White color for the underline before focus
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "gray", // White color on hover
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "gray", // White color after focus
                      },
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                size="small"
                color="primary"
                type="text"
                label="Transaction ID"
                variant="standard"

                fullWidth={true}
                name="transactionId"
                value={transactionId}
                onChange={(e) => onInputChange(e, "number")}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // White color for the underline before focus
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "gray", // White color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "gray", // White color after focus
                  },
                }}
              ></TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                select
                size="small"
                color="primary"
                type="text"
                variant="standard"

                label="Transaction Type"
                fullWidth={true}
                name="transactionType"
                defaultValue={transactionType || "Select Transaction Type"}
                onChange={(e) => onInputChange(e, "alphabet")}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // White color for the underline before focus
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "gray", // White color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "gray", // White color after focus
                  },
                }}
              >
                <MenuItem
                  value="Select Transaction Type"
                  selected="Select Transaction Type"
                >
                  Select Transaction Type
                </MenuItem>
                {(() => {
                  if (getTransactionTypeListResArray) {
                    return getTransactionTypeListResArray.map((c) => (
                      <MenuItem value={c} key={c}>
                        {c === "PURCHASE"
                          ? "Purchase"
                          : c === "LOAD"
                            ? "Fund Top-up"
                            : c === "RECEIVED"
                              ? "Fund Received"
                              : c === "SEND"
                                ? "Fund Transfer"
                                : c === "WITHDRAW"
                                  ? "Withdraw"
                                  : c === "BANK TRANSFER"
                                    ? "Bank Transfer"
                                    : c}
                      </MenuItem>
                    ));
                  } else {
                    return <MenuItem>No Data</MenuItem>;
                  }
                })()}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                select
                size="small"
                color="primary"
                type="text"
                label="Transaction SubType"
                variant="standard"

                fullWidth={true}
                name="transactionSubType"
                defaultValue={
                  "Select Transaction Sub Type" || transactionSubType
                }
                onChange={(e) => onInputChange(e, "alphabet")}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // White color for the underline before focus
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "gray", // White color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "gray", // White color after focus
                  },
                }}
              >
                <MenuItem
                  value="Select Transaction Sub Type"
                  selected="Select Transaction Sub Type"
                >
                  Select SubType
                </MenuItem>
                {transactionSubTypeList &&
                  []
                    .concat(transactionSubTypeList)
                    .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                select
                size="small"
                color="primary"
                type="text"
                label="Currency"
                variant="standard"

                required
                fullWidth={true}
                name="currency"
                defaultValue={"Select Currency" || currency}
                onChange={(e) => onInputChange(e, "alphabet")}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // White color for the underline before focus
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "gray", // White color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "gray", // White color after focus
                  },
                }}
              >
                <MenuItem value="Select Currency" selected="Select Currency">
                  Select Currency
                </MenuItem>
                {adminCurrencyCodes.success &&
                  []
                    .concat(adminCurrencyCodes.data.currencyList)
                    .map((x) => (
                      <MenuItem value={x.substring(x.indexOf("-") + 1)}>
                        {x.substring(x.indexOf("-") + 1)}
                      </MenuItem>
                    ))}
              </TextField>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                select
                size="small"
                color="primary"
                variant="standard"

                type="text"
                label="Show Fee Transactions"
                fullWidth={true}
                name="isFee"
                defaultValue={"All" || isFee}
                onChange={(e) => onInputChange(e, "alphabet")}
              >
                <MenuItem selected="All" value="All">
                  All
                </MenuItem>
                <MenuItem selected="Y" value="Y">
                  Yes
                </MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </Grid> */}
            {/* <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                select
                size="small"
                disabled={isFee === "N" ? true : false}
                color="primary"
                type="text"
                variant="standard"

                label="Fee Type"
                fullWidth={true}
                name="feeType"
                defaultValue={"Select Fee Type" || feeType}
                onChange={(e) => onInputChange(e, "alphabet")}
              >
                <MenuItem selected="Select Fee Type" value="Select Fee Type">
                  Select Fee Type
                </MenuItem>
                <MenuItem value="Fee Paid">Fee Paid</MenuItem>
                <MenuItem value="Fee Received">Fee Received </MenuItem>
              </TextField>
            </Grid> */}

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Autocomplete
                id="combo-box-demo"
                options={dataAutocompleteName || []}
                getOptionLabel={(option) =>
                  option
                    ?

                    option.customerMobileOrName
                    : ``
                }
                filterOptions={filterOptions}
                value={autocompleteDataName}
                onChange={(event, value) => setautocompleteDataName(value)}
                renderInput={(params) => (
                  <TextField
                    autoFocus
                    size="small"
                    // margin="dense"
                    label="Name"
                    variant="standard"

                    // style={{ marginTop: "3px" }}
                    type="text"
                    fullWidth={true}
                    {...params}
                    name="toCustName"
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "gray", // White color for the underline before focus
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "gray", // White color on hover
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "gray", // White color after focus
                      },
                    }}
                  />
                )}
              />
            </Grid>
            {/* <Grid item xs={12} sm={12} md={3} lg={3}>
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Name"
                type="tel"
                fullWidth
                value={toCustName}
                name="toCustName"
                onChange={handleChange}
                style={{ marginTop: "3px" }}
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <TextField
                select
                autoFocus
                margin="dense"
                id="name"
                label="Transaction Status"
                type="tel"
                variant="standard"

                fullWidth
                style={{ marginTop: "3px" }}
                name="transStatus"
                onChange={handleChange}
                defaultValue={"All" || transStatus}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // White color for the underline before focus
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "gray", // White color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "gray", // White color after focus
                  },
                }}
              >
                <MenuItem value="All" selected="All">
                  All
                </MenuItem>
                <MenuItem value="Success">Success</MenuItem>
                <MenuItem value="Failed">Failed</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Processing">Processing</MenuItem>
                <MenuItem value="Cancelled">Cancelled</MenuItem>
                <MenuItem value="Declined">Declined</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Autocomplete
                id="combo-box-demo"
                options={dataAutocomplete || []}
                getOptionLabel={(option) =>
                  option
                    ? "+" +
                    option.countryCode +
                    " " +
                    option.mobile +
                    "-" +
                    option.customerMobileOrName
                    : ``
                }
                filterOptions={filterOptions}
                value={autocompleteData}
                onChange={(event, value) => setautocompleteData(value)}
                renderInput={(params) => (
                  <TextField
                    autoFocus
                    margin="dense"
                    label="Contact"
                    style={{ marginTop: "3px" }}
                    type="text"
                    fullWidth
                    variant="standard"

                    {...params}
                    name="customerOrMobName"
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "gray", // White color for the underline before focus
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "gray", // White color on hover
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "gray", // White color after focus
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                select
                size="small"
                color="primary"
                variant="standard"

                type="text"
                label="Show Fee Transactions"
                fullWidth={true}
                name="isFee"
                defaultValue={"All" || isFee}
                onChange={(e) => onInputChange(e, "alphabet")}
              >
                <MenuItem selected="All" value="All">
                  All
                </MenuItem>
                <MenuItem selected="Y" value="Y">
                  Yes
                </MenuItem>
                <MenuItem value="N">No</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
              
              <TextField
                size="small"
                color="primary"
                type="text"
                // label="Invoice Id"
                label={invoiceLabelS}
                variant="standard"

                fullWidth={true}
                name="invoiceid"
                value={invoiceid}
                onChange={handleChange}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "gray", // White color for the underline before focus
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottomColor: "gray", // White color on hover
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "gray", // White color after focus
                  },
                }}
              ></TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <CustomButton
                style={{
                  padding: "8px"
                }}
                // endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getWalletTransactionListReq}
              >
                Search<SearchIcon />
              </CustomButton>
            </Grid>
          </Grid>
        </Card>

        {isLoading ? (
          <LoadingSpinner />
        ) : getWalletTransactionListArray.length == undefined ||
          getWalletTransactionListArray.status == "NOT FOUND" ||
          getWalletTransactionListArray.status == "Failed" ||
          !getWalletTransactionListStatus ? (
          <Card>
            <Grid
              container
              style={{
                padding: "10px",
              }}
            >
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Typography
                  variant="body1"
                  style={{ fontWeight: "700" }}
                  className="themeText"
                >
                  Transactions List
                </Typography>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Alert className="my-3 tableHeaderColor" variant="secondary">
                  No Records Found!
                </Alert>
              </Grid>
            </Grid>
          </Card>
        ) : (
          <Card>
            <Grid
              container
              style={{
                padding: "10px",
              }}
            >
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Typography
                  variant="body1"
                  style={{ fontWeight: "700" }}
                  className="themeText"
                >
                  Transactions List
                </Typography>
              </Grid>
              <Grid
                container
                style={{
                  padding: "10px",
                  textAlign: "center",
                  justifyContent: "right",
                }}
              >
                <Grid item xs={4} sm={4} md={1} lg={1}>
                  <img
                    // src={Excel}
                    src={`${process.env.PUBLIC_URL}/${Theme}/excel.png`}

                    style={{ height: "30px", cursor: "pointer" }}
                    onClick={() => {
                      getTransactionReportFileExcelOrPdf(csv);
                    }}
                  ></img>
                </Grid>
                <Grid item xs={4} sm={4} md={1} lg={1}>
                  <img
                    // src={PDF}
                    src={`${process.env.PUBLIC_URL}/${Theme}/pdf1.png`}

                    style={{ height: "30px", cursor: "pointer" }}
                    onClick={() => {
                      getTransactionReportFileExcelOrPdf(pdf);
                    }}
                  ></img>
                </Grid>
              </Grid>
              <TableContainer component={Paper} className="my-3">
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow className="tableHeaderColor">
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        {" "}
                        Status
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Transaction Date
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        {" "}
                        Transaction Id
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        {val.walletOwnerId === "199" || val.walletOwnerId === "201" || val.walletOwnerId == "200"
                          ? "Invoice ID"
                          : "Order Description"}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        {" "}
                        Transaction Type
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        To Customer
                      </TableCell>



                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Transaction Amount
                      </TableCell>

                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Action
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Details
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {getWalletTransactionListArray &&
                      []
                        .concat(getWalletTransactionListArray)
                        // .slice(
                        //   page * rowsPerPage,
                        //   page * rowsPerPage + rowsPerPage
                        // )
                        .map((row, index) => (
                          <>
                            <TableRow key={index}>
                              <TableCell align="center" style={{ borderBottom: "0" }}>                             {row.status === "Success" && (
                                <Tooltip title="Success">
                                  <FaCheckCircle style={{ color: '#3fc908' }} size={20} />
                                </Tooltip>
                              )}
                                {row.status === "Failed" && (
                                  <Tooltip title="Failed">
                                    <MdCancel style={{ color: 'red' }} size={20} />
                                  </Tooltip>
                                )}
                                {row.status === "Pending" && (
                                  <Tooltip title="Pending">
                                    <FaClock style={{ color: 'grey' }} size={20} />
                                  </Tooltip>
                                )}
                                {row.status === "Processing" && (
                                  <Tooltip title="Processing">
                                    <ImSpinner11 style={{ color: '#ddcf05ff' }} size={20} />
                                  </Tooltip>
                                )}
                                {row.status === "Cancelled" && (
                                  <Tooltip title="Cancelled">
                                    <TiCancel style={{ color: '#dd0505ff' }} size={25} /> 
                                  </Tooltip>
                                )}
                                {row.status === "Declined" && (
                                  <Tooltip title="Declined">
                                    <TiCancel style={{ color: '#000000ff' }} size={20} />
                                  </Tooltip>
                                )}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderBottom: "0" }}
                              >
                                {row.registeredTime}
                              </TableCell>

                              {/* <TableCell
                                align="center"
                                style={{ borderBottom: "0" }}
                              >
                                {row.status}
                              </TableCell> */}

                              <TableCell
                                align="center"
                                style={{ borderBottom: "0" }}
                              >
                                {row.transactionId}
                              </TableCell>

                              {/* <Col md={6}>
                                <Row>{val.walletOwnerId == "1" || val.walletOwnerId == "199" || val.walletOwnerId == "201" ? (
                                  <>
                                    <Col md={6}>Invoice ID</Col>
                                    <Col md={6}>
                                      {row.orderDescription || row.orderDescription === ""
                                        ? "-"
                                        : row.orderDescription}
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <Col md={6}>Order Description</Col>
                                    <Col md={6}>
                                      {row.orderDescription || row.orderDescription === ""
                                        ? "-"
                                        : row.orderDescription}
                                    </Col>
                                  </>
                                )}
                                </Row>
                              </Col> */}

                              <TableCell align="center" style={{ borderBottom: "0" }}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                  <span>
                                    {row.orderDescription ? row.orderDescription : "-"}
                                  </span>
                                </div>
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderBottom: "0" }}
                              >
                                {row.transactionType}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderBottom: "0" }}
                              >
                                {row.toCustName}
                              </TableCell>


                              <TableCell align="center" style={{ borderBottom: "0" }}>
                                {getSymbolFromCurrency(row.currency) +
                                  " " +
                                  row.amount}
                              </TableCell>
                              {/* <TableCell
                                align="center"
                                style={{ borderBottom: "0" }}
                                className={
                                  (row.creditAmount > 0
                                    ? "text-success"
                                    : row.debitAmount > 0
                                      ? "text-danger"
                                      : "") + " font-weight-bold"
                                }
                              >
                                {getSymbolFromCurrency(row.currency) +
                                  " " +
                                  (row.creditAmount > 0
                                    ? row.creditAmount
                                    : row.debitAmount > 0
                                      ? row.debitAmount
                                      : row.amount)}
                              </TableCell> */}

                              <TableCell align="center">
                                <Grid
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={12}
                                  style={{ display: "flex" }}
                                >
                                  <Tooltip title="Update">
                                    <CustomButton
                                      // disabled={(row.transactionStatus == "Pending" || row.transactionStatus == "Success") ? false : true}
                                      disabled={row.status !== "Pending"}
                                      style={{
                                        padding: "8px",
                                        marginLeft: "10px",
                                      }}
                                      onClick={() =>
                                        updateHandleClick(row.transactionId)
                                      }
                                    >
                                      <EditIcon
                                        style={{
                                          color: "#fff",
                                          fontSize: "20px",
                                        }}
                                      />
                                    </CustomButton>
                                  </Tooltip>
                                </Grid>
                              </TableCell>
                              <TableCell style={{ borderBottom: "0" }}>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={() => {
                                    onButtonClick(row.transactionId);
                                    if (row.isRefundDisplay === "Y") {
                                      getRefundDetailsAdminReq(row.walletOwnerId, row.transactionId)

                                    }
                                    getWalletTransactionListByIdReq(row.walletOwnerId, row.transactionId, row.currency,);

                                  }}
                                >
                                  {open == row.transactionId ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                style={{ paddingBottom: 0, paddingTop: 0 }}
                                colSpan={10}
                              >
                                <Collapse
                                  in={open == row.transactionId}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <Box margin={4}>
                                    {adminGetWalletTransactionListById.data
                                      .transactionMasterDetailsResponseVO &&
                                      adminGetWalletTransactionListById.data
                                        .transactionMasterDetailsResponseVO ? (
                                      <>
                                        {getWalletTransList && (
                                          <Table
                                            className={classes.table}
                                            aria-label="a dense table"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            <TableBody>
                                              {getWalletTransList &&
                                                []
                                                  .concat(getWalletTransList)
                                                  .map((row, index) => (
                                                    <TableRow key={index}>
                                                      <Row>
                                                        <Col md={12}>
                                                          <Typography
                                                            variant="h6"
                                                            component="div"
                                                            className="mt-3"
                                                            style={{
                                                              fontSize: "1.4rem",
                                                            }}
                                                          >
                                                            Customer Info
                                                          </Typography>
                                                          <hr />
                                                          <Row>
                                                            <Col md={6} class="detail-info row">
                                                              <Row>
                                                                <Col md={6}>From Customer</Col>
                                                                <Col md={6}>
                                                                  {" "}
                                                                  {!row.fromCustName || row.fromCustName == ""
                                                                    ? "-"
                                                                    : row.fromCustName}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                            <Col md={6} class="detail-info row">
                                                              <Row>
                                                                <Col md={6}>From Customer Contact</Col>
                                                                <Col md={5}>
                                                                  {row.fromContact === '-' ? '' :
                                                                    row.fromContact ?
                                                                      isMasked ?
                                                                        row.fromContact.split(' ').length == 1 ?
                                                                          'XX-XXXX-' + row.fromContact.substring(row.fromContact.length - 4) :
                                                                          `+${row.fromContact.split(' ')[0]} ` +
                                                                          'XX-XXXX-' +
                                                                          row.fromContact.split(' ')[1].substring(row.fromContact.split(' ')[1].length - 4) :
                                                                        row.fromContact.split(' ').length == 1 ?
                                                                          row.fromContact :
                                                                          `+${row.fromContact}`
                                                                      : '-'
                                                                  }
                                                                </Col>
                                                                <Col md={1}><span style={{ cursor: "pointer" }} onClick={() => setIsMasked(!isMasked)}> {isMasked ? <VisibilityOff className="EyeIcons" /> : <Visibility className="EyeIcons" />}
                                                                </span> </Col>
                                                              </Row>


                                                            </Col>

                                                          </Row>
                                                          <hr />
                                                          <Row>
                                                            <Col md={6} class="detail-info row">
                                                              <Row>
                                                                <Col md={6}>Beneficiary Name</Col>
                                                                <Col md={6}>
                                                                  {row.statusDescription == "Top Up in Wallet" || !row.toCustName ? "-" : row.toCustName}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                            <Col md={6} class="detail-info row">
                                                              <Row>
                                                                <Col md={6}>Beneficiary Contact</Col>
                                                                <Col md={5}>
                                                                  {/* {row.statusDescription === "Top Up in Wallet" || !row.toCustomerContact ? "-" :row.toCustomerContact} */}

                                                                  {row.statusDescription === "Top Up in Wallet" || !row.toCustomerContact ? "-" :
                                                                    row.toCustomerContact === "-" ? '-' :
                                                                      row.toCustomerContact ?
                                                                        isMaskedToContact ?
                                                                          row.toCustomerContact.split(' ').length == 1 ?
                                                                            'XX-XXXX-' + row.toCustomerContact.substring(row.toCustomerContact.length - 4) :
                                                                            `+${row.toCustomerContact.split(' ')[0]} ` +
                                                                            'XX-XXXX-' +
                                                                            row.toCustomerContact.split(' ')[1].substring(row.toCustomerContact.split(' ')[1].length - 4) :
                                                                          row.toCustomerContact.split(' ').length == 1 ?
                                                                            row.toCustomerContact :
                                                                            `+${row.toCustomerContact}`
                                                                        : '-'
                                                                  }
                                                                </Col>
                                                                <Col md={1}><span style={{ cursor: "pointer" }} onClick={() => setIsMaskedToContact(!isMaskedToContact)}>
                                                                  {isMaskedToContact ?
                                                                    row.statusDescription === "Top Up in Wallet" || !row.toCustomerContact || row.toCustomerContact === "-" ? "" :


                                                                      <VisibilityOff className="EyeIcons" /> : <Visibility className="EyeIcons" />}

                                                                </span> </Col>


                                                                {/* {row.statusDescription == "Top Up in Wallet" || !row.toCustomerContact ? "-" :
																									<Col md={4}> {isMaskedToContact ? "xxxx-xxxx-" + row.toCustomerContact.substring(8, 12) : row.toCustomerContact}
																										<span onClick={() => setIsMaskedToContact(!isMaskedToContact)}> {isMaskedToContact ? <Visibility /> : <VisibilityOff />}</span>

																									</Col>




																								} */}


                                                                {/* <Col md={4}> {isMasked ? "xxxx-xxxx-" + row.toCustomerContact.substring(8, 12) : row.toCustomerContact} </Col>
																								<Col md={2}><span onClick={() => setIsMasked(!isMasked)}> {isMasked ? <Visibility /> : <VisibilityOff />}</span></Col> */}


                                                              </Row>

                                                            </Col>

                                                          </Row>
                                                          <hr />
                                                          <Row>
                                                            <Col md={12}>
                                                              <Typography
                                                                variant="h6"
                                                                component="div"
                                                                className="mt-3"
                                                                style={{
                                                                  fontSize: "1.4rem",
                                                                  paddingTop: "3.5%",
                                                                  paddingBottom: "1.5%",
                                                                }}
                                                              >
                                                                Transaction Info
                                                              </Typography>
                                                              <hr />

                                                              <Row>
                                                                <Col md={6} class="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>Status Description</Col>
                                                                    <Col md={6}>
                                                                      {" "}
                                                                      {!row.statusDescription || row.statusDescription == ""
                                                                        ? "-"
                                                                        : row.statusDescription}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>
                                                                <Col md={6} class="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>Transaction Amount</Col>
                                                                    <Col md={6}>
                                                                      {!row.amount || row.amount == ""
                                                                        ? "-"
                                                                        : row.amount}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>
                                                              </Row>
                                                              <hr />
                                                              <Row>
                                                                <Col md={6} class="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>Transaction Sub Type</Col>
                                                                    <Col md={6}>
                                                                      {" "}
                                                                      {!row.transactionSubType || row.transactionSubType == ""
                                                                        ? "-"
                                                                        : row.transactionSubType}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>
                                                                <Col md={6} class="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>Tracking ID</Col>
                                                                    <Col md={6}>
                                                                      {" "}
                                                                      {!row.trackingId || row.trackingId == ""
                                                                        ? "-"
                                                                        : row.trackingId}
                                                                    </Col>
                                                                  </Row>

                                                                </Col>
                                                              </Row>
                                                              <hr />
                                                              <Row>
                                                                <Col md={6} class="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>From Wallet</Col>
                                                                    <Col md={6}>
                                                                      {row.statusDescription == "Top Up in Wallet" ? "-" : row.fromWallet}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>
                                                                <Col md={6} class="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>Beneficiary Wallet</Col>
                                                                    <Col md={6}>
                                                                      {" "}
                                                                      {!row.toWallet || row.toWallet == ""
                                                                        ? "-"
                                                                        : row.toWallet}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>
                                                              </Row>
                                                              <hr />
                                                              <Row>
                                                                <Col md={6}>
                                                                  <Row>{val.walletOwnerId == "199" || val.walletOwnerId == "201" || val.walletOwnerId == "200" ? (
                                                                    <>
                                                                      <Col md={6}>Invoice ID</Col>
                                                                      <Col md={6}>
                                                                        {" "}
                                                                        {!row.orderDescription || row.orderDescription == ""
                                                                          ? "-"
                                                                          : row.orderDescription}
                                                                      </Col>
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      <Col md={6}>Order Description</Col>
                                                                      <Col md={6}>
                                                                        {" "}
                                                                        {!row.orderDescription || row.orderDescription == ""
                                                                          ? "-"
                                                                          : row.orderDescription}
                                                                      </Col>
                                                                    </>
                                                                  )}
                                                                  </Row>
                                                                </Col>
                                                                <Col md={6} class="detail-info row">
                                                                  <Row>

                                                                    <Col md={6}>Remark</Col>
                                                                    <Col md={6}>
                                                                      {" "}
                                                                      {!row.remark || row.remark == ""
                                                                        ? "-"
                                                                        : row.remark}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>
                                                              </Row>

                                                              <hr />
                                                              {adminGetWalletTransactionListById?.data?.transactionMasterDetailsResponseVO.transactionSubType === "Offline Bank Transfer" &&
                                                                <Row>
                                                                  <Col md={6} class="detail-info row">
                                                                    <Row>
                                                                      <Col md={6}>Exchange Rate </Col>
                                                                      <Col md={6}>
                                                                        {" "}
                                                                        1 GBP = {
                                                                          !row.convertedAmount || row.convertedAmount == ""
                                                                            ? "-"
                                                                            : `${row.convertedAmount} ${row.convertedCurrency}`
                                                                        }
                                                                      </Col>
                                                                    </Row>
                                                                  </Col>
                                                                  <Col md={6} class="detail-info row">
                                                                    <Row>

                                                                      <Col md={6}>Amount Paid</Col>
                                                                      <Col md={6}>
                                                                        {" "}
                                                                        {
                                                                          !row.convertedRate || row.convertedRate == ""
                                                                            ? "-"
                                                                            : `${row.convertedRate} ${row.convertedCurrency}`
                                                                        }
                                                                      </Col>
                                                                    </Row>
                                                                  </Col>
                                                                </Row>
                                                              }
                                                              {/* <hr /> */}
                                                              {row.transactionType === "REFUND" ? (
                                                                <>
                                                                  {/* <hr /> */}

                                                                  <Row>
                                                                    <Col
                                                                      md={6}
                                                                      class="detail-info row"
                                                                    >
                                                                      <Row>
                                                                        <Col md={6}>Parent ID</Col>
                                                                        <Col md={6}>
                                                                          <Typography
                                                                            style={{
                                                                              color: "blue",
                                                                              cursor: "pointer",
                                                                              fontWeight: "bold",
                                                                              color: "blue",
                                                                            }}
                                                                            onClick={() => {

                                                                              handleParentOpen(
                                                                                row.parentId
                                                                              );
                                                                            }}
                                                                          >
                                                                            {" "}
                                                                            {!row.parentId ||
                                                                              row.parentId == ""
                                                                              ? "-"
                                                                              : row.parentId}
                                                                          </Typography>
                                                                        </Col>
                                                                      </Row>
                                                                    </Col>

                                                                    {row.isRefundDisplay === "Y" && refundFlag ? (
                                                                      <Col
                                                                        md={6}
                                                                        class="detail-info row"
                                                                      >
                                                                        <Row>
                                                                          <Col md={6}>
                                                                            <Typography
                                                                              style={{
                                                                                color: "Blue",
                                                                                margin: "0px",
                                                                              }}
                                                                              // variant="contained"
                                                                              onClick={() => {
                                                                                setGetRefundOpenModal(true);;
                                                                              }}
                                                                            >
                                                                              Refund Details
                                                                            </Typography>
                                                                          </Col>
                                                                          {/* <Col md={6} >
																							<Typography style={{ color: "blue", cursor: "pointer",fontWeight: 'bold', color: "blue" }} onClick={()=>{setGetParentIdOnClick(row.parentId);
																							handleParentOpen(row.parentId)}}>	{" "}
																								{!row.parentId || row.parentId == ""
																									? "-"
																									: row.parentId}
																									</Typography>
																							</Col> */}
                                                                        </Row>
                                                                      </Col>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                  </Row>
                                                                </>
                                                              ) : (
                                                                ""
                                                              )}
                                                              {row.transactionType !== "REFUND" &&
                                                                row.isRefundDisplay === "Y" && refundFlag && (
                                                                  <>
                                                                    {/* <hr /> */}


                                                                    <Row>
                                                                      <Col md={6}>
                                                                        <Typography
                                                                          style={{
                                                                            color: "Blue",
                                                                            margin: "0px",
                                                                            cursor: "pointer"
                                                                          }}
                                                                          // variant="contained"
                                                                          onClick={() => { setGetRefundOpenModal(true); }}
                                                                        // onClick={() => { getRefundDetailsPartnerReq(row.walletOwnerId, row.transactionId); }}
                                                                        >
                                                                          Refund Details
                                                                        </Typography>
                                                                      </Col>
                                                                    </Row>
                                                                  </>
                                                                )}
                                                              {/* {row.isFee === "Yes" ? (
																																	<Col
																																		md={6}
																																		class="detail-info row"
																																	>
																																		<Row>
																																			<Col md={6} style={{padding:"10px 0 0 0"}}>
																																			<Typography
																																						style={{
																																							color: "Blue",
																																							fontWeight:"600",
																																							cursor: "pointer",
																																							
																																						
																																						}}
																																						// variant="contained"
																																						// onClick={() => { setGetRefundOpenModal(true); }}
																																					onClick={() => { handleFeeDetailsOpen(row.walletOwnerId, row.transactionId); }}
																																					>
																																					Fee Details
																																					</Typography>
																																				
																																			</Col>

																																		</Row>
																																	</Col>
																																) : (
																																	""
																																)} */}


                                                              <hr />
                                                              {(row.feeType === 'No' || row.feeType === '') ? '' :
                                                                <Row>
                                                                  <Col md={6} class="detail-info row">
                                                                    <Row>

                                                                      <Col md={6}>Fee Type</Col>
                                                                      <Col md={6}>
                                                                        {" "}
                                                                        {!row.feeType || row.feeType == ""
                                                                          ? "-"
                                                                          : row.feeType}
                                                                      </Col>
                                                                    </Row>
                                                                  </Col>

                                                                </Row>
                                                              }
                                                              {(row.feeType === 'No' || row.feeType === '') ? "" :
                                                                <hr />}
                                                            </Col>
                                                          </Row>
                                                        </Col>

                                                      </Row>
                                                      {
                                                        (
                                                          (row.firstSix && row.firstSix !== '-') ||
                                                          (row.lastFour && row.lastFour !== '-') ||
                                                          (row.cardHolderName && row.cardHolderName !== '-') ||
                                                          (row.binCountry && row.binCountry !== '-')
                                                        ) && (
                                                          <Row>
                                                            <Col md={12}>
                                                              <Typography
                                                                variant="h6"
                                                                component="div"
                                                                className="mt-3"
                                                                style={{ fontSize: "1.4rem" }}
                                                              >
                                                                Account Details
                                                              </Typography>
                                                              <hr />

                                                              {/* ACCOUNT HOLDER */}
                                                              <Row>
                                                                <Col md={6} className="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>Account Holder</Col>
                                                                    <Col md={6}>
                                                                      {row.cardHolderName ? row.cardHolderName : "-"}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>

                                                                {/* NET BANKING CONDITION HERE ↓↓↓ */}
                                                                {adminGetWalletTransactionListById?.data?.transactionMasterDetailsResponseVO.transactionSubType === "Net Banking" ? (
                                                                  <Col md={6} className="detail-info row">
                                                                    <Row>
                                                                      <Col md={6}>Account</Col>
                                                                      <Col md={6}>{row.bankName || "-"}</Col>
                                                                    </Row>
                                                                  </Col>
                                                                ) : (
                                                                  <Col md={6} className="detail-info row">
                                                                    <Row>
                                                                      <Col md={6}>Account Number</Col>
                                                                      <Col md={6}>
                                                                        {row.firstSix === "-" || row.firstSix === "" ||
                                                                          row.lastFour === "-" || row.lastFour === ""
                                                                          ? "-"
                                                                          : `${row.firstSix}-XXXXXX-${row.lastFour}`}
                                                                      </Col>
                                                                    </Row>
                                                                  </Col>
                                                                )}
                                                              </Row>

                                                              <hr />

                                                              {/* BIN COUNTRY */}
                                                              <Row>
                                                                <Col md={6} className="detail-info row">
                                                                  <Row>
                                                                    <Col md={6}>Bin Country</Col>
                                                                    <Col md={6}>
                                                                      {row.binCountry && row.binCountry !== "-" && (
                                                                        <img
                                                                          src={countryFlagS(row.binCountry)}
                                                                          style={{
                                                                            height: "20px",
                                                                            width: "20px",
                                                                            marginRight: "10px"
                                                                          }}
                                                                          alt={`${row.binCountry} flag`}
                                                                        />
                                                                      )}
                                                                      {row.binCountry || "-"}
                                                                    </Col>
                                                                  </Row>
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      }
                                                      {/* {(row.firstSix === '-' || row.firstSix === '') && (row.lastFour === '-' || row.lastFour === '') &&
                                                        (row.cardHolderName === '-' || row.cardHolderName === '')
                                                        && (row.binCountry === '-' || row.binCountry === '')
                                                        ? '' :
                                                        <Row>
                                                          <Col md={12}>
                                                            <Typography
                                                              variant="h6"
                                                              component="div"
                                                              className="mt-3"
                                                              style={{
                                                                fontSize: "1.4rem",
                                                              }}
                                                            >
                                                              Account Details
                                                            </Typography>
                                                            <hr />
                                                            <Row >
                                                              <Col md={6} class="detail-info row">
                                                                <Row>

                                                                  <Col md={6}>Account Holder</Col>
                                                                  <Col md={6}>
                                                                    {!row.cardHolderName || row.cardHolderName == ""
                                                                      ? "-"
                                                                      : row.cardHolderName}

                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                              <Col md={6} class="detail-info row">
                                                                <Row>

                                                                  <Col md={6}>Account Number</Col>
                                                                  <Col md={6}> */}
                                                      {/* {!row.firstSix + "xxxx" + !row.lastFour ||
																											row.firstSix + "xxxx" + row.lastFour === "" ? "-"
																											: row.firstSix + "xxxx" + row.lastFour} */}
                                                      {/* {!row.firstSix + !row.lastFour ||
                                                                      row.firstSix + row.lastFour === "" ? "-"
                                                                      : row.firstSix + "-" + "XXXXXX" + "-" + row.lastFour}

                                                                  </Col>
                                                                </Row>
                                                              </Col> */}
                                                      {/* <Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>Bin Country</Col>
																									<Col md={6}>

																										{!row.binCountry || row.binCountry == ""
																											? "-"
																											: row.binCountry}

																									</Col>
																								</Row>
																							</Col> */}
                                                      {/* </Row>
                                                            <hr />

                                                            <Row> */}
                                                      {/* <Col md={6} class="detail-info row">
                                                                <Row>

                                                                  <Col md={6}>Bin Country</Col>
                                                                  <Col md={6}>
                                                                    {row.binCountry && row.binCountry === "-" ? "" :
                                                                      (<img src={countryFlagS(row.binCountry)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)}
                                                                    {!row.binCountry || row.binCountry === "" ? "-" : row.binCountry}</Col> */}
                                                      {/* <Col md={6}>
																										{!row.binCountry || row.binCountry == ""
																											? "-"
																											: row.binCountry}
																									</Col> */}
                                                      {/* </Row>
                                                              </Col>
                                                            </Row> */}
                                                      {/* <Row >
																							<Col md={6} class="detail-info row">
																								<Row>

																									<Col md={6}>First Six</Col>
																									<Col md={6}>
																										{!row.firstSix || row.firstSix == ""
																											? "-"
																											: row.firstSix}
																									</Col>
																								</Row>
																							</Col>
																							<Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>Last Four</Col>
																									<Col md={6}>
																										{!row.lastFour || row.lastFour == ""
																											? "-"
																											: row.lastFour}
																									</Col>
																								</Row>
																							</Col>
																						</Row>
																						<hr /> */}
                                                      {/* 
                                                          </Col>
                                                        </Row>
                                                      } */}

                                                      {(row.deviceFingerPrint === '-' || row.deviceFingerPrint === '') && (row.customerIp === '-' || row.customerIp === '') ? '' :

                                                        <Row>
                                                          <Col md={12}>
                                                            <Typography
                                                              variant="h6"
                                                              component="div"
                                                              className="mt-3"
                                                              style={{
                                                                fontSize: "1.4rem",
                                                              }}
                                                            >
                                                              Device Info
                                                            </Typography>
                                                            <hr />
                                                            <Row>

                                                              {/* <Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>IP Address</Col>
																									<Col md={6}>
																										{" "}
																										{!row.customerIp || row.customerIp == ""
																											? "-"
																											: row.customerIp}
																									</Col>
																								</Row>
																							</Col> */}
                                                              <Col md={6} class="detail-info row">
                                                                {/* <Row> */}
                                                                {/* <Col md={6}>IP Country</Col> */}
                                                                {/* <Col md={6}>
																										{" "}
																										{!row.ipFlag || row.ipFlag == ""
																											? "-"
																											: row.ipFlag}
																									</Col> */}
                                                                {/* <Col md={6}>
																										{row.ipFlag && row.ipFlag === "-" ? "" :
																											(<img src={countryFlag(row.ipFlag)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)}
																									</Col> */}
                                                                {/* </Row> */}
                                                                <Row>
                                                                  <Col md={6}>IP Address</Col>
                                                                  <Col md={6}>
                                                                    {row.ipFlag && row.ipFlag === "-" ? "" :
                                                                      (<img src={countryFlag(row.ipFlag)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)}
                                                                    {!row.customerIp || row.customerIp == "" ? "-" : row.customerIp}</Col>
                                                                </Row>
                                                              </Col>
                                                              <Col md={6} class="detail-info row">
                                                                <Row>
                                                                  <Col md={6}>Device</Col>
                                                                  <Col md={6}>
                                                                    {" "}
                                                                    {row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device : "-"}
                                                                  </Col>
                                                                </Row>
                                                              </Col>

                                                            </Row>
                                                            <hr />
                                                            <Row >
                                                              <Col md={6} class="detail-info row">
                                                                <Row>
                                                                  <Col md={6}>Device Density</Col>
                                                                  <Col md={6}>
                                                                    {" "}
                                                                    {row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Density != "" ? JSON.parse(`${row.deviceFingerPrint}`).Density : "-"}
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                              <Col md={6} class="detail-info row">
                                                                <Row>
                                                                  <Col md={6}>Device Memory</Col>
                                                                  <Col md={6}>
                                                                    {" "}
                                                                    {row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device_Memory != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device_Memory : "-"}
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                              {/* <Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>Device</Col>
																									<Col md={6}>
																										{" "}
																										{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device : "-"}
																									</Col>
																								</Row>
																							</Col> */}
                                                            </Row>
                                                            <hr />
                                                            <Row>

                                                              <Col md={6} class="detail-info row">
                                                                <Row>
                                                                  <Col md={6}>Device UUID</Col>
                                                                  <Col md={6}>
                                                                    {" "}
                                                                    {row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device_UUID != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device_UUID : "-"}
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                              <Col md={6} class="detail-info row">
                                                                <Row>
                                                                  <Col md={6}>OS</Col>
                                                                  <Col md={6}>
                                                                    {" "}
                                                                    {row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).OS != "" ? JSON.parse(`${row.deviceFingerPrint}`).OS : "-"}
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                            </Row>
                                                            <hr />
                                                            <Row >


                                                              <Col md={6} class="detail-info row">
                                                                <Row>
                                                                  <Col md={6}>OS Version</Col>
                                                                  <Col md={6}>
                                                                    {" "}
                                                                    {row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).OS_Version != "" ? JSON.parse(`${row.deviceFingerPrint}`).OS_Version : "-"}
                                                                  </Col>
                                                                </Row>
                                                              </Col>

                                                            </Row>


                                                          </Col>
                                                        </Row>
                                                      }

                                                    </TableRow>

                                                  ))}
                                            </TableBody>
                                          </Table>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </>
                        ))}
                  </TableBody>
                </Table>
                {/* <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={[].concat(getWalletTransactionListArray).length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                /> */}
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={getWalletTransactionListRes.data.count}
                  rowsPerPage={rowsPerPage}
                  page={pageNo}
                  // ActionsComponent={TablePaginationActions}
                  onPageChange={handleChangePageForward}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                // handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Grid>
          </Card>
        )}
        {getWalletTransactionListArray.length == undefined ||
          !getWalletTransactionListStatus ? (
          <Card style={{ display: "none" }}></Card>
        ) : (
          <div style={{ display: "none" }}>
            <TableContainer component={Paper}>
              <Table className={classes.table} id="walletTransation">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Transaction Date </TableCell>
                    <TableCell align="center"> Transaction Id</TableCell>
                    <TableCell align="center"> Transaction Type</TableCell>
                    <TableCell align="center">Transaction Amount</TableCell>
                    <TableCell align="center">DSR Contact</TableCell>
                    <TableCell align="center">To Customer</TableCell>
                    <TableCell align="center">Commission</TableCell>
                    <TableCell align="center">Credit</TableCell>
                    <TableCell align="center">Debit</TableCell>
                    <TableCell align="center">Balance</TableCell>
                    <TableCell align="center">Transaction Status</TableCell>
                    <TableCell align="center">Remark</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getWalletTransactionListArray &&
                    []
                      .concat(getWalletTransactionListArray)
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">{row.fromDate}</TableCell>
                          <TableCell align="center">
                            {row.transactionId}
                          </TableCell>
                          <TableCell align="center">
                            {row.transactionType}
                          </TableCell>
                          <TableCell align="center">
                            {row.transactionAmount}
                          </TableCell>
                          <TableCell align="center"></TableCell>
                          <TableCell align="center">
                            {row.toCustomerName}
                          </TableCell>
                          <TableCell align="center"></TableCell>
                          <TableCell align="center">
                            {row.creditAmount}
                          </TableCell>
                          <TableCell align="center">
                            {row.debitAmount}
                          </TableCell>
                          <TableCell align="center">{row.balance}</TableCell>
                          <TableCell align="center">
                            {row.transactionStatus}
                          </TableCell>
                          <TableCell align="center">{row.remark}</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </Layout>
      <div>
        <Dialog open={viewOpen} onClose={closeEditModal}>
          <DialogTitle style={{ minWidth: "600px" }}>
            Transaction Summary
          </DialogTitle>
          <DialogContent>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="To Customer Contact"
              fullWidth={true}
              name="toCustContact"
              value={toCustContact || ""}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="To Customer Name"
              fullWidth={true}
              name="toCustomerName"
              value={toCustomerName || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Balance"
              fullWidth={true}
              name="toBalance"
              value={toBalance || ""}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Transaction Status"
              fullWidth={true}
              name="TransactionStatus"
              value={TransactionStatus || ""}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Ip Address"
              fullWidth={true}
              name="ipAdd"
              value={ipAdd.length ? ipAdd : "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Credit"
              fullWidth={true}
              name="Credit"
              value={Credit || ""}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Debit"
              fullWidth={true}
              name="Debit"
              value={Debit || ""}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Remark"
              fullWidth={true}
              name="Remark"
              value={remark || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Currency"
              fullWidth={true}
              name="Currency"
              value={toCurrency || ""}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              format="MM/dd/yyyy"
              label="Date & Time"
              fullWidth={true}
              name="fromDATE"
              value={fromDATE || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Is Fee"
              fullWidth={true}
              name="IsFee"
              value={IsFee || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="Transaction Amount"
              fullWidth={true}
              name="TransactionAmt"
              value={TransactionAmt || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="From Customer Id"
              fullWidth={true}
              name="FromCustomerId"
              value={fromCustID || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              autoFocus={true}
              type="text"
              label="From Customer Name"
              fullWidth={true}
              name="fromCustName"
              value={fromCustName || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="Device Density"
              fullWidth={true}
              name="density"
              value={density || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="Device"
              fullWidth={true}
              name="device"
              value={device || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="Device Memory"
              fullWidth={true}
              name="deviceMemory"
              value={deviceMemory || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="Device UUID"
              fullWidth={true}
              name="deviceUUID"
              value={deviceUUID || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="os"
              fullWidth={true}
              name="os"
              value={os || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
            <TextField
              style={{ marginTop: "10px" }}
              size="small"
              color="primary"
              type="text"
              label="OS Version"
              fullWidth={true}
              name="osVersion"
              value={osVersion || "-"}
              onChange={handleChange}
              disabled
            ></TextField>
          </DialogContent>
          <DialogActions style={{ padding: "14px" }}>
            <CustomButton
              style={{
                color: "white",
              }}
              variant="contained"
              onClick={closeEditModal}
            >
              Close
            </CustomButton>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog open={parentDetails} onClose={closeEditModal}>
          <DialogTitle style={{ minWidth: "600px" }}>
            Transaction Summary
          </DialogTitle>
          <DialogContent>
            <Row>
              <Col md={12}>
                <Typography
                  variant="h6"
                  component="div"
                  className="mt-3"
                  style={{
                    fontSize: "1.4rem",
                  }}
                >
                  Customer Info
                </Typography>
                <hr />
                <Row>
                  <Col md={6} class="detail-info row">
                    <Row>
                      <Col md={6}>From Customer</Col>
                      <Col md={6}>
                        {" "}
                        {/* {!row.fromCustName || row.fromCustName == ""
														? "-"
														: row.fromCustName} */}
                        {/* {getWalletTransactionListRes.data.transactionList} */}
                        {getWalletTransactionListRes.data.transactionList &&
                          getWalletTransactionListRes.data.transactionList
                            .fromCustName
                          ? getWalletTransactionListRes.data.transactionList
                            .fromCustName
                          : "-"}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions style={{ padding: "14px" }}>
            <CustomButton
              style={{
                color: "white",
              }}
              variant="contained"
              onClick={closeEditModal}
            >
              Close
            </CustomButton>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog open={openUpdateModal} onClose={handleClose}>
          <DialogTitle style={{ width: "400px" }}>Update Details</DialogTitle>
          <DialogContent>
            <TextField
              style={{ marginTop: "10px" }}
              // select
              size="small"
              color="primary"
              // autoFocus={true}
              type="text"
              label="Transaction ID"
              fullWidth={true}
              name="orgnDesc"
              variant="standard"
              value={orgnDesc || ""}
              onChange={handleChange}
              disabled
            />
            <TextField
              select
              autoFocus
              margin="dense"
              label="Status"
              name="updateStatus"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleChange}
              defaultValue={"Select Status"}
            >
              <MenuItem value="Success">Success</MenuItem>
              <MenuItem value="Failed">Failed</MenuItem>
              {/* <MenuItem value="Pending">Pending</MenuItem> */}
            </TextField>

            <TextField
              autoFocus
              margin="dense"
              label="Remark"
              name="getRemark"
              type="text"
              fullWidth
              variant="standard"
              onChange={handleChange}
              value={getRemark || ""}
            />
            {/* <TextField
							select
							autoFocus
							margin="dense"
							label="Status"
							name="updateStatus"
							type="text"
							fullWidth
							variant="standard"
							onChange={handleChange}
							defaultValue={updateStatus || "Select Status"}
						>
							<MenuItem value="Success">Success</MenuItem>
							<MenuItem value="Failed">Failed</MenuItem>
							<MenuItem value="Pending">Pending</MenuItem>

						</TextField> */}
          </DialogContent>
          <DialogActions>
            <CustomButton
              style={{
                padding: "8px",
              }}
              onClick={handleClose}
            >
              Cancel
            </CustomButton>
            <CustomButton
              disabled={!getRemark && !updateStatus}
              style={{
                padding: "8px",
              }}
              onClick={getUpdateGateWayReq}
            >
              Update
            </CustomButton>
          </DialogActions>
        </Dialog>
      </div>
      {console.log(
        "admin111",
        adminUpdateWalletTransactionStatusRes,
        "wwwwww",
        viewUpdateResArray
      )}

      {(viewUpdateResArray.status === "success" ||
        viewUpdateResArray.status === "Success") && (
          <div>
            {/* {console.log("success view arr",viewUpdateResArray)} */}
            <Dialog open={notificationUpdateStatusOpen} onClose={handleNoticationClose}>
              <DialogContent
                className="text-center"
                style={{ backgroundColor: "#00b9f51c" }}
              >
                <img src={success} alt="" width="100px" className="my-2" />
              </DialogContent>
              <DialogContent>
                <h4
                  style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                >
                  {adminUpdateWalletTransactionStatusRes.data.description}
                </h4>
              </DialogContent>
              <DialogActions style={{ justifyContent: "center" }}>
                <Button
                  style={{
                    margin: "10px 0",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  variant="contained"
                  onClick={handleNoticationClose}
                >
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )}

      {/* {viewUpdateResArray.status == "success" && (
        <div>
          <Dialog open={notificationRefundOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={success} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {viewUpdateResArray.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}


      {viewUpdateResArray.status == "Failed" && (
        <div>
          <Dialog open={notificationUpdateStatusOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {viewUpdateResArray.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
      {viewUpdateResArray.status == "failed" && (
        <div>
          <Dialog open={notificationUpdateStatusOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {viewUpdateResArray.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}




      {(getRefundOpenModal && (adminGetRefundDetailsRes.data.status !== "Success" || adminGetRefundDetailsRes.data.status !== "success")) && <Dialog open={getRefundOpenModal} onClose={handleClose} >
        {adminGetRefundDetailsRes.data.status == "failed" || adminGetRefundDetailsRes.data.status == "Failed" ? <DialogContent >
          <DialogContent style={{ display: "flex", justifyContent: "center" }} >    <img src={failed} alt="" width="100px" className="my-2" /></DialogContent>
          <DialogContent >{adminGetRefundDetailsRes.data.description}</DialogContent></DialogContent> : ""}

        <DialogActions className="p-3">
          <CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
            Close
          </CustomButton>
        </DialogActions> </Dialog>}


      <div>
        {(getRefundOpenModal && (adminGetRefundDetailsRes.data.status == "Success" || adminGetRefundDetailsRes.data.status == "success")) && (
          <Dialog open={getRefundOpenModal} onClose={handleClose} maxWidth="md" fullWidth>
            <>
              <DialogTitle>Refund Details</DialogTitle>
              <DialogContent dividers>
                <TableContainer component={Paper} style={{ overflow: 'hidden' }}>
                  <Table>
                    <TableHead>
                      <TableRow className="themeBackground">
                        <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                          Transaction Id
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                          Currency
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                          Amount
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                          Status
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                          Transaction Sub-Type
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                          Remark
                        </TableCell>
                        <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                          Date
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {adminGetRefundDetailsRes.data.Response && [].concat(adminGetRefundDetailsRes.data.Response).map((row) => {
                        return <TableRow>
                          <TableCell align="center" style={{ borderBottom: "0" }}>
                            {row.transactionId}
                          </TableCell>
                          <TableCell align="center" style={{ borderBottom: "0" }}>
                            {row.currency}

                          </TableCell>
                          <TableCell align="center" style={{ borderBottom: "0" }}>
                            {row.amount}

                          </TableCell>
                          <TableCell align="center" style={{ borderBottom: "0" }}>
                            {row.status}
                          </TableCell>
                          <TableCell align="center" style={{ borderBottom: "0" }}>
                            {row.transactionSubType}

                          </TableCell>
                          <TableCell align="center" style={{ borderBottom: "0" }}>
                            {row.remark}

                          </TableCell>
                          <TableCell align="center" style={{ borderBottom: "0" }}>
                            {row.registeredTime.split(" ")[0]}

                          </TableCell>
                        </TableRow>
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </DialogContent>
              <DialogActions className="p-3">
                <CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
                  Close
                </CustomButton>
              </DialogActions></>
          </Dialog>
        )}
      </div>

      <div>
        {((getFeeDetailsOpenModal && (partnerGetFeeDetailsByIDRes.data.status == "success" || partnerGetFeeDetailsByIDRes.data.status == "success")) && (partnerGetFeeDetailsByIDRes.data.status !== "Success" || partnerGetFeeDetailsByIDRes.data.status !== "success")) && (
          <Dialog open={getFeeDetailsOpenModal} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Fee Details</DialogTitle>
            <DialogContent dividers style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow className="themeBackground">
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Transaction Id
                      </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Currency
                      </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Amount
                      </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Status
                      </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Transaction Sub-Type
                      </TableCell>

                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Remark
                      </TableCell>

                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Status Description
                      </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Fee Type
                      </TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                        Date
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {partnerGetFeeDetailsByIDRes.data.Response && [].concat(partnerGetFeeDetailsByIDRes.data.Response).map((row) => {
                      return <TableRow>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.id}
                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.currency}

                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.amount}

                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.status}
                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.transactionSubType}

                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.remark}

                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.statusDescription}

                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.feeType}

                        </TableCell>
                        <TableCell align="center" style={{ borderBottom: "0" }}>
                          {row.registeredTime.split(" ")[0]}

                        </TableCell>
                      </TableRow>
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions className="p-3">
              <CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
                Close
              </CustomButton>
            </DialogActions>
          </Dialog>
        )}
      </div>




      <div>
        <Dialog open={parentIdModal} onClose={() => setparentIdModal(false)}>
          <DialogTitle style={{ minWidth: "600px" }}>
            Parent Transaction Details
          </DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex' }}>
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Transaction ID"
                fullWidth={true}
                name="transactionId"
                value={parentDetailsArr.transactionId || "-"}
              />
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Amount"
                fullWidth={true}
                name="amount"
                value={parentDetailsArr.amount || "-"}
              />
            </div>
            <div style={{ display: 'flex' }}>
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Status"
                fullWidth={true}
                name="status"
                value={parentDetailsArr.status || "-"}
              />
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Transaction Type"
                fullWidth={true}
                name="transactionType"
                value={parentDetailsArr.transactionType || "-"}
              />
            </div>
            <TextField
              style={{ margin: "10px 4px 0" }}
              size="small"
              type="text"
              disabled
              label="Transaction Date"
              fullWidth={true}
              name="registeredTime"
              value={parentDetailsArr.registeredTime || "-"}
            />
            <h1 style={{ marginTop: "1.5rem", marginBottom: '0', fontSize: "16px" }} > Customer Info </h1>
            <div style={{ display: 'flex' }}>
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="From Customer"
                fullWidth={true}
                name="fromCustName"
                value={parentDetailsArr.fromCustName || "-"}
              />
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="From Customer Contact"
                fullWidth={true}
                name="fromContact"
                value={parentDetailsArr.fromContact || "-"}
              />
            </div>
            <div style={{ display: 'flex' }}>
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Benificiary"
                fullWidth={true}
                name="toCustName"
                value={parentDetailsArr.toCustName || "-"}
              />
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Benificiary Contact"
                fullWidth={true}
                name="toCustomerContact"
                value={parentDetailsArr.toCustomerContact || "-"}
              />
              {/* <Input
								type={hiddenPassword ? "password" : "text"}
								id="fromCustContact"
								label="From Customer Contact"
								name="toCustomerContact"
								fullWidth
								value={parentDetailsArr.toCustomerContact}
								endAdornment={
								<InputAdornment position="end">
									<IconButton
									onClick={toggleShow}
									>
									{hiddenPassword ? (
										<VisibilityOff />
									) : (
										<Visibility />
									)}
									</IconButton>
								</InputAdornment>
								}
							/> */}
            </div>
            <h1 style={{ marginTop: "1.5rem", marginBottom: '0', fontSize: "16px" }} > Transaction Info </h1>
            <div style={{ display: 'flex' }}>
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="From Wallet"
                fullWidth={true}
                name="fromWallet"
                value={parentDetailsArr.fromWallet ? parentDetailsArr.fromWallet.split(' ')[0] : '-' || "-"}
              />
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="To Wallet"
                fullWidth={true}
                name="toWallet"
                value={parentDetailsArr.toWallet ? parentDetailsArr.toWallet.split(' ')[0] : '-' || "-"}
              />
            </div>
            <div style={{ display: 'flex' }}>
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Transaction Sub Type"
                fullWidth={true}
                name="transactionSubType"
                value={parentDetailsArr.transactionSubType || "-"}
              />
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Order Description"
                fullWidth={true}
                name="orderDescription"
                value={parentDetailsArr.orderDescription || "-"}
              />
            </div>
            <div style={{ display: 'flex' }}>
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Status Description"
                fullWidth={true}
                name="statusDescription"
                value={parentDetailsArr.statusDescription || "-"}
              />
              <TextField
                style={{ margin: "10px 4px 0" }}
                size="small"
                type="text"
                disabled
                label="Remark"
                fullWidth={true}
                name="remark"
                value={parentDetailsArr.remark || "-"}
              />
            </div>
            {
              (!parentDetailsArr.cardHolderName || parentDetailsArr.cardHolderName === '' || parentDetailsArr.cardHolderName === '-') &&
                (!parentDetailsArr.firstSix || parentDetailsArr.firstSix === '' || parentDetailsArr.firstSix === '-') &&
                (!parentDetailsArr.lastFour || parentDetailsArr.lastFour === '' || parentDetailsArr.lastFour === '-') &&
                (!parentDetailsArr.binCountry || parentDetailsArr.binCountry === '' || parentDetailsArr.binCountry === '-') ? '' : (
                <>
                  <h1 style={{ marginTop: "1.5rem", marginBottom: '0', fontSize: "16px" }} > Account Details </h1>
                  <div style={{ display: 'flex' }}>
                    <TextField
                      style={{ margin: "10px 4px 0" }}
                      size="small"
                      type="text"
                      disabled
                      label="Account Holder"
                      fullWidth={true}
                      name="cardHolderName"
                      value={parentDetailsArr.cardHolderName || "-"}
                    />
                    <TextField
                      style={{ margin: "10px 4px 0" }}
                      size="small"
                      type="text"
                      disabled
                      label="Account Number"
                      fullWidth={true}
                      name="remark"
                      value={
                        (!parentDetailsArr.firstSix || parentDetailsArr.firstSix == "-") || (!parentDetailsArr.lastFour || parentDetailsArr.lastFour == "-") ?
                          '-' :
                          parentDetailsArr.firstSix + '-XXXXXX-' + parentDetailsArr.lastFour
                          || "-"}
                    />
                  </div>
                  <TextField
                    style={{ margin: "10px 4px 0" }}
                    size="small"
                    type="text"
                    disabled
                    label="Bin Country"
                    fullWidth={true}
                    name="binCountry"
                    value={
                      (!parentDetailsArr.binCountry || parentDetailsArr.binCountry === '' || parentDetailsArr.binCountry === "-" ? "" :
                        (<img src={countryFlags(parentDetailsArr.binCountry.replace(/(\w)(\w*)/g,
                          function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); }))} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)) +
                        !parentDetailsArr.binCountry || parentDetailsArr.binCountry == "" ? "-" : parentDetailsArr.binCountry.replace(/(\w)(\w*)/g,
                          function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })
                      || "-"}
                  />
                </>
              )
            }
            {
              (!parentDetailsArr.ip || parentDetailsArr.ip === '' || parentDetailsArr.ip === '-') ? '' : (
                <>
                  <h1 style={{ marginTop: "1.5rem", marginBottom: '0', fontSize: "16px" }} > Device Details </h1>
                  <TextField
                    style={{ margin: "10px 4px 0" }}
                    size="small"
                    type="text"
                    disabled
                    label="IP Address"
                    fullWidth={true}
                    name="ipAddress"
                    value={
                      !parentDetailsArr.ipFlag || parentDetailsArr.ipFlag === "-" ? "-" :
                        (<img src={countryFlags(parentDetailsArr.ipFlag.replace(/(\w)(\w*)/g,
                          function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); }))} style={{ height: "20px", width: "20px", marginRight: "10px" }} />) +
                          !parentDetailsArr.ip || parentDetailsArr.ip == "" ? "-" : parentDetailsArr.ip
                        || "-"}
                  />
                </>
              )
            }
          </DialogContent>
          <DialogActions style={{ justifyContent: "end" }}>
            <CustomButton
              color="primary"
              style={{ padding: '6px 8px', borderRadius: '4px' }}
              type="submit"
              onClick={() => setparentIdModal(false)}
            >
              Ok
            </CustomButton>
          </DialogActions>
        </Dialog>
      </div>


    </>
  );
}

export default AdminWalletTransaction;
